import React, { Fragment } from 'react';
import { getUrlParameter } from '@tickled-media/web-components.tm-helpers';
import { defaultLang, isBeYeuTemplate } from '../../config'

export const HtmlEn = () => {
	const lang = getUrlParameter('lng') || defaultLang;

	const openTab = (tabSelected, tabLink, tabCountry) => {
	    // const tabContent = document.getElementsByClassName('tabcontent'),
	    const tabLabel = document.getElementsByClassName('tab-label');
	    for(const label of tabLabel) {
	        label.classList.remove('tab-visited');
	    }
	    if(tabSelected === 'english') {
	        document.getElementById('english').classList.remove('hide');
	        document.getElementById(tabCountry).classList.add('hide');
	    }
	    else {
	        document.getElementById('english').classList.add('hide');
	        document.getElementById(tabCountry).classList.remove('hide');
	    }
	    document.getElementById(tabLink).classList.add('tab-visited');
	}

	let ContentHtml = '';
	switch (lang) {
        case 'th':
            ContentHtml = <ContentThHtml openTab={openTab} />;
            break;

        case 'id':
            ContentHtml = <ContentIdHtml openTab={openTab} />;
            break;

        case 'vn':
            ContentHtml = <ContentVnHtml />;
            break;

        case 'ph':
            ContentHtml = <ContentPhHtml />;
            break;

        case 'my':
            ContentHtml = <ContentMyHtml openTab={openTab} />;
            break;

        default:
            ContentHtml = <ContentEnHtml />;
            break;
    }

	if (isBeYeuTemplate) {
		ContentHtml = <ContentBeYeuHtml />;	
	}

	return ContentHtml;
};



const ContentEnHtml = () => (
    <Fragment>
    	<div className="community-guildeline-title-wrapper">		
			<h1 className="community-guildeline-title">
			theAsianparent Community Guidelines
			</h1>
			<br/>
		</div>
		<div className="starting-para">
			<p>
			Hi Parents! We are so excited that you can join us on your journey to parenthood!
			</p>
			<br />
			<p>
			We welcome and support moms and dads (or prospective parents) to stay in touch on our platform to share advice and stories based on personal experiences. 
			</p>
			<br />
			<p>
			However, we encourage parents not to judge each other despite differences in parenting styles, cultures, ages, beliefs, etc.
			</p>
			<br/>
			<p>
			In addition, in order to maintain security and comfort in the community, please make sure to adhere to the following guidelines:
			</p>
		</div>
		<br/>
		<p className='point-title'>
			Integrity and identity
		</p>
		<br/>
		<p>
			We do not condone impersonating a person or entity that can harm other users. 
		</p>
		<br/>
		<p>
		If there is a report of impersonation, we will confirm and ask the user to revise their profile. 
		</p>
		<br/>
		<p>
		We also do not hesitate to suspend or block the account. 
		</p>
		<br/>
		<p>
		In addition, we do not allow users to share misinformation related to: 
		</p>
		<br/>
		<ol>
			<li>Emergencies that could cause panic </li>
			<li>Incitement to hatred or prejudice against other people, certain groups, or society </li>
			<li>Medical misinformation that could harm a person's physical health</li>
			<li>Content that misleads community members about politics  </li>
			<li>Conspiracy content that attacks certain groups </li>
			<li>Violent or tragic events.</li>
		</ol>
		<br/>
		<p>
		In addition, we do not allow users to share identity that contains personal or individual privacy information. 
		</p>
		<br/>
		<p>
		We are not responsible for any losses incurred as a result of sharing personal information by users. For this reason, we also do not recommend that users share personal information in the form of:
		</p>
		<br/>
		<ol>
			<li>Place and date of birth</li>
			<li>telephone number</li>
			<li>NIK(KTP main number)</li>
			<li>Complete address of residence</li>
			<li>Photo of identification card (KTP, SIM, Family Card, Birth certificate, etc.)</li>
			<li>Certificate ownership (house certificate, land certificate, etc.)</li>
			<li>Full name of mother and father</li>
			<li>Sign in information (username and password)</li>
			<li>Debit/credit card number, etc.</li>
		</ol>
		<br/>
		<p className='point-title'>
			Inappropriate images
		</p>
		<br/>
		<p>
		As a platform for parenting and pregnancy, we really understand if you want to exchange stories related to spots/ vaginal discharge/ baby poop and so on with other users.
		</p>
		<br/>
		<p>
		Unfortunately, this may make other users feel less comfortable.
		</p>
		<br/>
		<p>
		For this reason, we do not recommend users to post sensitive images such as human/baby feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on without using <i>the tag</i> NSFW (Not Safe for Work).
		</p>
		<br/>
		<p>
		Users who post sexually explicit photos, especially children, will be removed.
		</p>
		<br/>
		<p className='point-title'>
		Spam 
		</p>
		<br/>
		<p>
		As our commitment to provide users with a good experience when interacting on our platform, we will remove any <i>spam</i> content. 
		</p>
		<br/>
		<p>
		To that end, we ask each user not to share content or engage in spammy behavior.  
		</p>
		<br/>
		<p>
		We do not support all of the following posts, responses or comments:
		</p>
		<br/>
		<ol>
			<li>Share a post/response/comment more than 2 (two) times with the same words or sentences</li>
			<li>Containing <i>spam</i> elements, such as: up, “period”, “comma”, etc.</li>
			<li>Provide comments that contain spam elements on personal or other people's posts with the aim of increasing posts to the homepage.</li>
			<li>Robotic text such as: nendifniuha3jr. 12345678, asdfghjkl, etc.</li>
			<li>Prohibitory sentence so that other users do not answer a post, such as "Posts from 1 year ago do not respond!"</li>
			<li>Linking to other websites whose security cannot be guaranteed (whatsapp group links, Facebook, Instagram, Line, etc.)</li>
		</ol>
		<br/>
		<p className='point-title'>
		Illegal activities 
		</p>
		<br/>
		<p>
		We do not support activities that violate laws and regulations. For this reason, we prohibit all activities related to criminal acts on our platform.
		</p>
		<br/>
		<p>
		We prohibit all user on the platform from participating in conversations or activities related to: 
		</p>
		<br/>
		<ol>
			<li>Exploitation of people/children</li>
			<li>Weapons</li>
			<li>Poisoning of humans</li>
			<li>Any life-threatening activities</li>
			<li>Phishing</li>
			<li>Fraud/scam/false investment</li>
			<li>Theft</li>
			<li>Spreading pornography</li>
			<li>Gambling</li>
			<li>Abortion</li>
			<li>Trafficking, promotion and use of Alcohol, Drugs, Substances and other illegal drugs.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Hateful, bullying, harassment and violent behavior
		</p>
		<br/>
		<p>
		We want to create a safe and comfortable community for users. Therefore, we do not tolerate any act of discrimination against certain individuals or groups.
		</p>
		<br/>
		<p>
		Please don't share posts/ feedback/ comments: 
		</p>
		<br/>
		<ol>
			<li>Referring negatively to other Individuals as animals, inanimate objects, or in any derogatory manner </li>
			<li>Calling for or justifying any acts of violence against other individuals or groups</li>
			<li>Claims of supremacy over a group of people based on race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
			<li>Accusing or slandering certain individuals or groups as criminals</li>
			<li>Posts/ responses/ comments that use slurs or harsh words</li>
			<li>Insulting or demeaning race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
			<li>Threats to other individuals</li>
			<li>Sharing personal details of others with malicious intent or otherwise</li>
			<li>Insults and solicitation of insults towards other individuals.</li>
		</ol>
		<br/>
		<p>
		We also do not tolerate when members of our community are humiliated, bullied or harassed. Therefore, any post/response/comment that contains any expressions of violence, including threats or disparaging statements intended to ridicule, insult, humiliate, intimidate, hurt someone or words that can cause severe psychological distress will be removed from our platform.
		</p>
		<br/>
		<p>
		We also do not allow any form of posts that contain elements of sexual harassment.
		</p>
		<br/>
		<p>
		Please do not share posts/feedback/comments that contain elements of:
		</p>
		<br/>
		<ol>
			<li>Disparage other people's sexual practices</li>
			<li>Altering or morphing other people's images to display or imply sexual suggestion or involvement in sexual activities</li>
			<li>Threatening or disclosing someone's private sex life, including threats to publish digital content, sex history, names of previous sexual partners, sexual orientation, etc.</li>
			<li>Threatening or exposing the sexual orientation of others</li>
		</ol>
		<br/>
		<p>
		In addition, we also do not allow users to share posts that contain elements of violence, such as:
		</p>
		<br/>
		<ol>
			<li>Sadism/Mutilation</li>
			<li>Open wounds</li>
			<li>Accidents</li>
			<li>Corpses </li>
			<li>Mutilated, charred or burned limbs</li>
			<li>Violence</li>
			<li>Torture, etc.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Suicide, self-harm and other dangerous acts
		</p>
		<br/>
		<p>
		As a <i>parenting</i> platform, we care deeply about the health and safety of our users. 
		</p>
		<br/>
		<p>
		For this reason, we do not condone any post that depicts, promotes or normalises any activity that leads to suicide, self-injury, or dangerous activities that can cause serious injury or even death. 
		</p>
		<br/>
		<p className='point-title'>
		Promotions
		</p>
		<br/>
		<p>
		We strive to provide convenience to every user of our application. For this reason, we only allow posts related to promotions, buying and selling activities or <i>giveaways</i> to be posted in the Buying and Selling <i>topic</i>.
		</p>
		<br/>
		<p>
		We will delete posts/responses/comments/ecommerce links/social media links that contain elements of promotion, buying and selling or <i>giveaways</i> outside the Buying and Selling <i>topic</i>
		</p>
		<br/>
		<p>
		We DO NOT allow the sale or administration of any drugs on our service! 
		</p>
		<br/>
		<p>
		No type of medicines may be given or sold by users on this platform.
		</p>
		<br/>
		<p>
		So, please don't share posts/responses/comments that contain:
		</p>
		<br/>
		<ol>
			<li>Suggestions for the use or administration of drugs</li>
			<li>Promotion or sale of chemicals, drugs, herbs, etc.</li>
		</ol>
		<br/>
		<p className='point-title'>
		theAsianparent Cares About Your Family's Safety from COVID-19
		</p>
		<br/>
		<p>
		Since the World Health Organisation (WHO) declared COVID-19 a pandemic in January 2020, we at theAsianparent have worked hard to keep our community safe by ensuring they have access to accurate information and limiting the spread of false information.
		</p>
		<br/>
		<p>
		Here's an overview of how we address this:
		</p>
		<br/>
		<p>
		We protect our community from those who perpetuate and spread false information.
		</p>
		<br/>
		<p>
		Our goal is to provide a safe, supportive and caring community and environment for parents during the pandemic. To address this, we actively monitor User Generated Content (UGC)*, and flag and remove any inappropriate content* that refers to viruses, provokes users about the World Health Organisation (WHO), as well as local government ministries of health.
		</p>
		<br/>
		<p>
		Before accessing the application, users are required to agree to the application's terms of use and/or user policies before creating or uploading content.
		</p>
		<br/>
		<p>
		In the same way, we deal with inappropriate content in our community.
		</p>
		<br/>
		<p>
		Here's how we deal with violators and prevent the spread of virus-related misinformation:
		</p>
		<br/>
		<ol>
			<li>If a member of our community tries to share any content or posts (including questions, responses, images and/or videos, links, hashtags) related to COVID-19, the content will automatically be detected by our system for internal moderators to look at. After that, users will also receive a notification directing them to the WHO website and the local health ministry.</li>
			<li>We allow users to flag inappropriate content, then ask our moderators to review the flagged content.</li>
		</ol>
		<br/>
		<p>
		The following is inappropriate content related to COVID-19:
		</p>
		<br/>
		<ol>
			<li>Sales of PPE, including protective clothing and footwear, masks, helmets, and goggles;</li>
			<li>Request donations on behalf of volunteers and businesses and communities affected by the pandemic - in return we will direct users to their official hotlines;</li>
			<li>Misleading content</li>
			<li>Content that involves spreading rumors and fake news.</li>
		</ol>
		<br/>
		<h2 className='faq'>Frequently Asked Questions (FAQ)</h2>
		<br/>
		<p className='point-title'>
			Who decides what the Community Guidelines should cover?
		</p>
		<br/>
		<p>
		theAsianparent is a community of people from diverse cultures, ages and beliefs.
		</p>
		<br/>
		<p>
		We have tried to understand different points of view to create a comfortable, safe and open community for everyone. 
		</p>
		<br/>
		<p>
		These Community Guidelines were created so that we can nurture and protect our community.
		</p>
		<br/>
		<p className='point-title'>
		Who moderates our platform?
		</p>
		<br/>
		<p>
		For our day-to-day moderation of the community, we are assisted by an advanced system that will detect violations of the Community Guidelines by users.
		</p>
		<br/>
		<p>
		However, our human moderators double check the system and the decisions made by it.
		</p>
		<br/>
		<p className='point-title'>
		I see that a post, response or comment on theAsianparent platform violates the Community Guidelines. What do I have to do?
		</p>
		<br/>
		<p>
		If you know another user is violating our Community Guidelines, please report them.
		</p>
		<br/>
		<p>
		You can tap the “REPORT USER” option from the menu drop-down which can be found by tapping the 3 dots (...) in the upper right corner of each post/response/comment.
		</p>
		<br/>
		<p>
		You can also email us the report (with evidence) to <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>
		</p>
		<br/>
		<p className='point-title'>
		What happens if someone violates our Community Guidelines?
		</p>
		<br/>
		<p>
		We have a policy for removing content that violates our Community Guidelines. We may remove an entire post if the associated image or text violates our Community Guidelines.
		</p>
		<br/>
		<p>
		We may also disable all accounts that violate our Community Guidelines.
		</p>
		<br/>
		<p>
		We may inform law enforcement, if we believe there is a risk of physical harm or threat to public safety.
		</p>
		<br/>
		<p className='point-title'>
		My post/response/comment suddenly disappeared, what happened?
		</p>
		<br/>
		<p>
		Currently theAsianparent has an Automatic Moderation System that can detect posts/comments that contain elements of bullying/spam/racist/illegal/vulgar photos and other inappropriate content.
		</p>
		<br/>
		<p>
		Our Automatic Moderation System will also follow up on the post/comment according to existing procedures (deleting posts/comments, blocking users, and so on).
		</p>
		<br/>
		<p>
		We will continue to monitor the Automatic Moderation System to make it even more perfect. We will also review posts/comments detected by the system.
		</p>
		<br/>
		<p>
		If the post/comment does not contain the elements mentioned above, we will reactivate it within 1x24 hours (working days).
		</p>
		<br/>
		<p className='point-title'>
		Why can users post using the Anonymous feature?
		</p>
		<br/>
		<p>
		The purpose of the anonymous feature is to help parents who want to share sensitive things that they can't tell others.
		</p>
		<br/>
		<p>
		If you notice any abuse of the anonymous feature, please report it to us at <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. We will follow up.
		</p>
		<br/>
		<p className='point-title'>
		What is an NSFW photo?
		</p>
		<br/>
		<p>
		<i>The</i> NSFW <i>tag</i> (Not Safe for Work) aims to prevent other users from being disturbed by posting certain photos.
		</p>
		<br/>
		<p>
		When attaching a photo to a post, you can find this "NSFW" checkbox at the bottom of the photo. By ticking "NSFW", the photo will be blurred and a warning will appear as an "unsafe to view" photo.
		</p>
		<br/>
		<p>
		We categorise several photos as "unsafe to view" namely female or male genitalia (be it a baby or adult), photos of fluid from female or male genitalia; nude photos (be it a baby or an adult), human/infant feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on.
		</p>
		<br/>
		<p>
		If this "vulgar" photo is not posted as NSFW, we will delete the photo and may suspend the account that uploaded it.
		</p>
		<br/><br/>
		<p>Cheers to raising happy, healthy, and confident kids!</p>
		<p className="covid-rule-title">&mdash;theAsianparent Team</p>
		<br/><br/> 
	</Fragment>
);

const ContentThHtml = (props) => (
   <Fragment>
   		<div className="language-tabs">
			<div onClick={() => props.openTab('english', 'englishContent', 'thai')} id="englishContent" className="tab-label">English</div>
			<div onClick={() => props.openTab('thai', 'thaiContent', 'thai')} id="thaiContent" className={`tab-label tab-visited`}>Thai</div>
		</div>

		<div id="thai" className="tabcontent">
	    	<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title">
				กฏระเบียบและข้อบังคับของชุมชน theAsianparent 
				</h1>
			</div>
			<div className="starting-para">
				<p>
				สวัสดีค่ะ คุณพ่อ คุณแม่ เราตื่นเต้นมาก ที่คุณได้ก้าวเข้ามาสู่เส้นทางของการเป็นคุณพ่อคุณแม่ร่วมกับเรา!
				</p>
				<br />
				<p>
				ยินดีต้อนรับทุกท่านนะคะ เราสนับสนุนให้คุณพ่อคุณแม่ (หรือทุกท่านที่กำลังจะเป็นพ่อแม่) มาร่วมกันแลกเปลี่ยนประสบการณ์ แบ่งปันเคล็ดลับ และคำแนะนำในการเลี้ยงดูลูกรัก จากประสบการณ์ส่วนตัว
				</p>
				<br/>
				<p>
				ทั้งนี้ เราสนับสนุนการแลกเปลี่ยนข้อมูล และประสบการณ์การเลี้ยงลูก บนพื้นฐานความคิดที่ไม่แบ่งแยกทั้งในเรื่องของอายุ วัฒนธรรม ความเชื่อ วิธีการเลี้ยงลูก หรือเรื่องใดก็ตามของการเป็นพ่อแม่
				</p>
				<br/>
				<p>
				เพื่อรักษาบรรยากาศในชุมชนให้เต็มไปด้วยความปลอดภัย และความสบายใจของทุกท่าน โปรดอ่าน และปฏิบัติตามกฏระเบียบและข้อบังคับของชุมชน ดังต่อไปนี้ค่ะ 
				</p>
				<br/>
			</div>
				<p className="point-title">
				ความซื่อสัตย์ และการแสดงอัตลักษณ์
				</p>
				<br/>
				<p>
				ทีมงานจะไม่เพิกเฉยกับผู้ที่แอบอ้างเป็นบุคคลหรือนิติบุคคลใด ที่อาจเป็นอันตรายต่อผู้ใช้งาน หากมีการรายงานการแอบอ้าง เราจะตรวจสอบและขอให้ผู้แอบอ้างนั้นแก้ไขโปรไฟล์ และในกรณีที่จำเป็น
				ทีมงานขอสงวนสิทธิ์ในการระงับหรือบล็อกบัญชีผู้ใช้ เพื่อความปลอดภัยของชุมชนและผู้ใช้งาน
				</p>
				<br/>
				<p>ดังนั้น เราจึงไม่อนุญาตให้ผู้ใช้งาน แชร์ข้อมูลเท็จที่เกี่ยวข้องกับ:</p>
				<br/>
				<ol>
					<li>เหตุฉุกเฉินที่อาจก่อให้เกิดความตื่นตระหนก</li>
					<li>การยั่วยุให้เกิดความเกลียดชังหรือสร้างอคติต่อบุคคล กลุ่มบุคคล หรือสังคมอื่น</li>
					<li>ข้อมูลทางการแพทย์ที่คลาดเคลื่อนหรือเป็นเท็จ ที่อาจเป็นอันตรายต่อสุขภาพร่างกายของบุคคลอื่น</li>
					<li>เนื้อหาเกี่ยวกับการเมือง ที่ทำให้สมาชิกคนอื่นอาจเข้าใจผิด</li>
					<li>เนื้อหาสมคบคิดที่พาดพิง หรือโจมตีกลุ่มบุคคลอื่น</li>
					<li>เหตุการณ์รุนแรงหรือโศกนาฏกรรม</li>
				</ol>
				<br/>
				<p>
				นอกจากนี้ ทางทีมงานไม่อนุญาตให้ผู้ใช้เผยแพร่ หรือเปิดเผยข้อมูลส่วนบุคคล ลงในแอปพลิเคชั่น และเราจะไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดขึ้นจากการเปิดเผยข้อมูลส่วนบุคคลจากตัวผู้ใช้งานเอง ด้วยเหตุนี้ เราจึงไม่แนะนำให้เปิดเผยข้อมูลส่วนบุคคลในรูปแบบของ:
				</p>
				<br/>
				<ol>
					<li>สถานที่เกิด และวันเกิด</li>
					<li>เบอร์ติดต่อ</li>
					<li>เลขบัตรประชาชน</li>
					<li>ที่อยู่โดยละเอียด</li>
					<li>รูปถ่ายบัตรประชาชน หรือเอกสารแสดงตัวตน (หน้าบัตรสำคัญต่างๆ สูติบัตร หรืออื่น ๆ)</li>
					<li>หนังสือรับรองความเป็นเจ้าของต่าง ๆ เช่น ทะเบียนบ้าน โฉนดที่ดิน หรืออื่น ๆ</li>
					<li>ชื่อนามสกุลจริงของบิดา และมารดา</li>
					<li>ข้อมูลการล็อกอินเข้าสู่ระบบ (username และ password)</li>
					<li>ข้อมูลเลขบัตรเครดิต/เดบิต อื่น ๆ</li>
				</ol>
				<br/>
				<p className='point-title'>
				รูปภาพที่ไม่เหมาะสม
				</p>
				<br/>
				<p>
				ในฐานะแพลตฟอร์มแลกเปลี่ยนข้อมูลการเป็นพ่อแม่และการเลี้ยงลูก เราเข้าใจดีว่า ผู้ใช้อาจต้องการแลกเปลี่ยนข้อมูลที่มีความละเอียดอ่อน เช่น จุดซ่อนเร้น ช่องคลอด อุจจาระของลูก หรือข้อมูลอื่น ๆ แต่ทางเราต้องขออภัยที่ต้องแจ้งว่า การกระทำดังกล่าว อาจสร้างความไม่สบายใจแก่ผู้ใช้ท่านอื่นด้วย ด้วยเหตุนี้ เราจึงไม่แนะนำให้ผู้ใช้โพสต์ภาพที่มีความละเอียดอ่อนดังกล่าว ยกตัวอย่าง ภาพอุจจาระของทารก ภาพผ้าอ้อมที่ถูกใช้งานแล้ว ภาพอาเจียน ภาพชุดชั้นใน ภาพแผลผ่าตัด มูกเลือด และภาพอื่น ๆ โดยที่ไม่กดปุ่มเบลอภาพ (NSFW) และหากพบรายงานรูปภาพที่มีเนื้อหาทางเพศ โดยเฉพาะภาพอวัยวะเพศเด็ก เราจะทำการลบทันที
				</p>
				<br/>
				<p className='point-title'>
				สแปม
				</p>
				<br/>
				<p>
				อุดมการณ์ของเรา คือการมอบประสบการณ์การใช้งานแอปฯ ที่ดีแก่ผู้ใช้งานอยู่เสมอ ดังนั้น เราจะดำเนินการลบเนื้อหาที่เป็นสแปมทันทีที่ตรวจเจอ
				</p>
				<br/>
				<p>
				ด้วยเหตุนี้ เราจึงขอความร่วมมือจากผู้ใช้ทุกท่าน โปรดอย่าแชร์เนื้อหาหรือตอบกลับกระทู้ หรือรูปภาพใด ๆ  ด้วยพฤติกรรมที่อาจส่อถึงการสแปมเนื้อหา
				</p>
				<br/>
				<p>
				เราจึงไม่อนุญาตให้ผู้ใช้งานแชร์โพสต์ ตอบกลับ หรือแสดงความคิดเห็นด้วยพฤติกรรมดังต่อไปนี้
				</p>
				<br/>
				<ol>
					<li>แชร์โพสต์/ตอบกลับ/แสดงความคิดเห็นมากกว่า 2 ครั้ง ด้วยคำหรือประโยคเดียวกัน</li>
					<li>พิมพ์อักษรหรือข้อความที่เป็นการสแปมเนื้อหา เช่น up เครื่องหมายจุด (.) เครื่องหมายคอมม่า (,) หรืออื่น ๆ</li>
					<li>แสดงความคิดเห็น โดยใช้ถ้อยคำที่ส่อถึงการสแปมเนื้อหา ในโพสต์ส่วนตัว หรือของผู้อื่น โดยมีเป้าหมายเพื่อให้โพสต์อยู่ในหน้าแรก</li>
					<li>พิมพ์ข้อความที่ไม่มีความหมาย เช่น nendifniuha3jr. 12345678, asdfghjk</li>
					<li>ใช้ประโยคหรือคำพูด สื่อความหมายว่าไม่ต้องการให้ผู้ใช้งานคนอื่นตอบกลับโพสต์ เช่น “โพสต์ไว้เมื่อ 1 ปีที่แล้ว อย่าตอบกลับ!"</li>
					<li>โพสต์ลิงก์ไปยังเว็บไซต์หรือแอปฯ อื่น ที่ไม่สามารถตรวจสอบ หรือรับรองความปลอดภัยได้ (whatsapp, facebook, instagram, line และ อื่น ๆ)</li>
				</ol>
				<br/>
				<p className='point-title'>
				กิจกรรมที่ละเมิดข้อบังคับทางกฎหมาย
				</p>
				<br/>
				<p>
				เราไม่สนับสนุนกิจกรรมที่ละเมิดกฎระเบียบ และข้อบังคับทางกฎหมาย ด้วยเหตุนี้ เราจึงไม่อนุญาตให้ทำกิจกรรมใด ๆ ที่อาจเกี่ยวข้องกับการกระทำความผิดทางอาญาบนแพลตฟอร์มของเรา
				</p>
				<br/>
				<p>
				โดยเราไม่อนุญาตให้ผู้ใช้ทุกคนบนแพลตฟอร์ม มีส่วนร่วมในกิจกรรมหรือการสนทนาที่เกี่ยวข้องกับ
				</p>
				<br/>
				<ol>
					<li>การแสวงหาประโยชน์จากเด็ก หรือบุคคลใด ๆ</li>
					<li>อาวุธ</li>
					<li>การใช้ยาพิษกับบุคคลใด ๆ</li>
					<li>การกระทำที่ไม่เหมาะสม และคุกคาม</li>
					<li>ชักจูงให้เปิดเผยข้อมูลส่วนตัว</li>
					<li>การสร้างข่าวลวง ปลุกปั่นกระแส และการฉ้อโกง</li>
					<li>การขโมย</li>
					<li>แพร่ภาพลามกอนาจาร</li>
					<li>การพนัน</li>
					<li>การทำแท้ง</li>
					<li>การค้ามนุษย์ การส่งเสริมและการใช้แอลกอฮอล์ ยาเสพติด และยาผิดกฎหมายอื่นๆ</li>
				</ol>
				<br/>
				<p className='point-title'>
				พฤติกรรมที่แสดงถึงความเกลียดชัง กลั่นแกล้ง รังแก เพื่อให้ผู้อื่นอับอาย ตลอดจนพฤติกรรมที่สื่อถึงความรุนแรงในรูปแบบต่าง ๆ 
				</p>
				<br/>
				<p>
				เราต้องการสร้างชุมชน ที่คุณพ่อคุณแม่สามารถเข้ามาพูดคุยกันได้อย่างปลอดภัย และสบายใจ ดังนั้น เราจะไม่เพิกเฉยต่อพฤติกรรมที่เป็นการคุกคาม ข่มขู่ ต่อบุคคลหรือกลุ่มบุคคลใด ๆ
				</p>
				<br/>
				<p>
				เราจึงไม่อนุญาตให้ผู้ใช้งานแชร์โพสต์ ตอบกลับ หรือแสดงความคิดเห็นด้วยพฤติกรรมดังต่อไปนี้
				</p>
				<br/>
				<ol>
					<li>การกล่าวอ้างถึงบุคคลอื่นด้วยถ้อยคำหยาบคาย หรือในลักษณะที่เสื่อมเสียใด ๆ เช่น การเปรียบเทียบว่าเป็นสัตว์ สิ่งของที่ไม่มีชีวิต ฯลฯ</li>
					<li>
					การเรียกร้อง หรือส่งเสริมการกระทำใด ๆ ที่แสดงออกถึงความรุนแรงในระดับบุคคล หรือกลุ่มบุคคล
					</li>
					<li> การเรียกร้องอำนาจเหนือกลุ่มบุคคลอื่น ในเรื่องเชื้อชาติ ชาติพันธุ์ ศาสนา โรคร้ายแรง ความทุพพลภาพ ฯลฯ</li>
					<li>การกล่าวหาหรือใส่ร้ายบุคคล หรือกลุ่มบุคคลอื่นว่าเป็นอาชญากร</li>
					<li>การโพสต์/ตอบกลับ/ หรือแสดงความคิดเห็นด้วยถ้อยคำที่หยาบคายหรือรุนแรง</li>
					<li>การดูถูก หรือดูหมิ่นเชื้อชาติ ชาติพันธุ์ ศาสนา โรคร้ายแรง ความทุพพลภาพ ฯลฯ</li>
					<li>การข่มขู่ที่จะใช้ความรุนแรงต่อบุคคลหรือกลุ่มบุคคลอื่น</li>
					<li>การเผยแพร่ข้อมูลส่วนตัวของบุคคลอื่น โดยไม่ได้รับอนุญาตหรือความยินยอม</li>
					<li>การดูหมิ่น และชักชวนหรือสนับสนุนให้เกิดการดูหมิ่นบุคคลอื่น</li>
				</ol>
				<br/>
				<p>
				เราจะไม่เพิกเฉยเมื่อเกิดการการกลั่นแกล้ง รังแก หรือทำให้สมาชิกคนใดคนหนึ่งในชุมชนของเราเกิดความอับอาย ดังนั้น หากเราพบข้อความใด ๆ ที่มีการแสดงออกถึงความรุนแรง การใช้คำหยาบคาย รวมถึงการข่มขู่ หรือใช้ข้อความดูหมิ่นที่มีจุดประสงค์เพื่อเยาะเย้ย ดูถูก ดูหมิ่น ทำให้รู้สึกอับอาย ถูกคุกคาม หรือสร้างความหวาดกลัว รวมถึงคำพูด ที่อาจทำให้เกิดความทุกข์ทางจิตใจอย่างรุนแรง จะถูกลบออกจากแพลตฟอร์มของเราทันที
				</p>
				<br/>
				<p>
				นอกจากนี้ เราไม่อนุญาตให้ผู้ใช้แชร์โพสต์รูปภาพหรือเนื้อหาใด ๆ ที่มีเนื้อหาเกี่ยวข้องหรือส่อถึงการล่วงละเมิด และการใช้ความรุนแรงทางเพศ
				</p>
				<br/>
				<p>
				เราจึงไม่อนุญาตให้ผู้ใช้งานแชร์โพสต์ ตอบกลับ หรือแสดงความคิดเห็นด้วยพฤติกรรมดังต่อไปนี้
				</p>
				<br/>
				<ol>
					<li>การดูหมิ่นรสนิยม หรือการแสดงออกทางเพศของผู้อื่น</li>
					<li>การแก้ไขหรือดัดแปลงรูปภาพของผู้อื่น เพื่อแสดงออก หรือสื่อนัยยะถึงการร่วมเพศ หรือชักชวนให้มีส่วนร่วมในกิจกรรมทางเพศ</li>
					<li>การข่มขู่ หรือเปิดเผยข้อมูลส่วนตัวทางเพศ รวมถึงการข่มขู่ที่จะเผยแพร่เนื้อหาดิจิทัล ประวัติการมีเพศสัมพันธ์ ชื่อของคู่นอนคนก่อน ๆ รสนิยมทางเพศ ฯลฯ ของผู้อื่น</li>
					<li>ข่มขู่ว่าจะเปิดเผย หรือเปิดเผยรสนิยมทางเพศของผู้อื่น</li>
				</ol>
				<br/>
				<p>
				นอกจากนี้ เรายังไม่อนุญาตให้ผู้ใช้ แชร์โพสต์รูปภาพหรือเนื้อหาใด ๆ ที่มีเนื้อเกี่ยวข้องหรือส่อถึงความรุนแรง เช่น
				</p>
				<br/>
				<ol>
					<li>การทารุณกรรม หรือการทำร้ายร่างกาย</li>
					<li>แผลสด</li>
					<li>อุบัติเหตุร้ายแรง</li>
					<li>ภาพของศพ</li>
					<li>อวัยวะที่ถูกตัดขาด ถูกไฟไหม้ หรือถูกทำลาย</li>
					<li>ความรุนแรงในรูปแบบต่าง ๆ</li>
					<li>การทรมาน และความรุนแรงอย่างโจ่งแจ้งในรูปแบบอื่น ๆ</li>
				</ol>
				<br/>
				<p className='point-title'>
				การฆ่าตัวตาย การทำร้ายตัวเอง และการกระทำที่เป็นอันตรายอื่นๆ
				</p>
				<br/>
				<p>
				ในฐานะที่เป็นแพลตฟอร์มสำหรับครอบครัว เราใส่ใจอย่างมากเกี่ยวกับสุขภาพ และความปลอดภัยของผู้ใช้ของเรา
				</p>
				<br/>
				<p>
				ด้วยเหตุผลนี้ เราจึงไม่อนุญาตให้ผู้ใช้งานโพสต์ข้อความหรือรูปภาพใด ๆ ที่มีส่วนสนับสนุนการทำร้ายตัวเอง การฆ่าตัวตาย หรือกิจกรรมที่เป็นอันตราย ซึ่งอาจก่อให้เกิดการบาดเจ็บร้ายแรงหรือถึงแก่ชีวิต
				</p>
				<br/>
				<p className='point-title'>					
					โปรโมชั่น
				</p>
				<br/>
				<p>
				เรามุ่งมั่นที่จะอำนวยความสะดวกให้กับผู้ใช้แอปพลิเคชันของเราทุกคน ด้วยเหตุผลนี้ เราจึงอนุญาตให้ผู้ใช้ มีสิทธิ์โพสต์รูปภาพ หรือข้อความใด ๆ ที่มีเนื้อหาเกี่ยวข้องกับโปรโมชั่น การซื้อ - ขายสินค้า หรือการแจกของรางวัล เฉพาะในหัวข้อซื้อขายสินค้าเท่านั้น
				</p>
				<br/>
				<p>
				และหากพบเจอข้อความหรือรูปภาพใด ๆ ขัดต่อกฎระเบียบข้อนี้ เช่น การโพสต์ลิงก์อีคอมเมิร์ซ หรือลิงก์โซเชียลมีเดียที่มีเนื้อหาเกี่ยวข้องกับการส่งเสริมการขาย การซื้อ - ขายสินค้า หรือการแจกของรางวัลนอกหัวข้อซื้อขายสินค้า เราจะลบโพสต์ดังกล่าวทันที
				</p>
				<br/>
				<p>
				และโปรดเข้าใจว่า เราไม่อนุญาตให้มีการซื้อ - ขายหรือให้บริการยาชนิดใด ๆ ในชุมชนของเรา!
				</p>
				<br/>
				<p>
				เราขอห้ามไม่ให้มีการให้บริการ หรือ ซื้อขายยาชนิดใด ๆ จากสมาชิกในแพลตฟอร์มของเรา
				</p>
				<br/>
				<p>
				ดังนั้น โปรดอย่าแชร์โพสต์ข้อความหรือรูปภาพใด ๆ ที่มีเนื้อหาดังต่อไปนี้
				</p>
				<br/>
				<ol>
					<li>ข้อแนะนำในการหาซื้อยา หรือ ใช้ยา</li>
					<li>การส่งเสริมการขายหรือจำหน่ายเคมีภัณฑ์ ยา สมุนไพร ฯลฯ</li>
				</ol>
				<br/>
				<p className='point-title'>
					ทีมงาน theAsianparent เป็นห่วงความปลอดภัยของสมาชิกชุมชน และครอบครัวของทุกคนในสถานการณ์การระบาดของ COVID-19 ครั้งนี้
				</p>
				<br/>
				<p>
				นับตั้งแต่ องค์การอนามัยโลก (WHO) ประกาศให้ COVID-19 เป็นโรคระบาดใหญ่อย่างเป็นทางการในเดือนมกราคมปี 2020 พวกเราทีมงาน theAsianparent ได้พยายามอย่างเต็มที่ เพื่อให้ชุมชนของเราปลอดภัยด้วยการทำให้แน่ใจว่า ทุกคนสามารถเข้าถึงข้อมูลที่ถูกต้อง และกำจัดการเปิดเผยข้อมูลที่เป็นเท็จ
				</p>
				<br/>
				<p>
				และนี่คือวิธีการที่ทีมงานของเราใช้ในการดูแลความปลอดภัยให้คุณ
				</p>
				<br/>
				<p>
				เราปกป้องชุมชนของเราจากผู้ใช้ที่แพร่และกระจายข้อมูลที่เป็นเท็จเกี่ยวกับโรคระบาด
				</p>
				<br/>
				<p>
				จุดมุ่งหมายของเราคือ การเป็นชุมชนที่มีความปลอดภัย พร้อมจะสนับสนุน และให้กำลังใจคุณพ่อคุณแม่ในสถานการณ์โรคระบาดนี้ ด้วยเหตุนี้ เราจึงตรวจสอบเนื้อหาที่ผู้ใช้สร้างขึ้นอย่างสม่ำเสมอ พร้อมแจ้งเตือนหรือลบโพสต์ใด ๆ ที่มีเนื้อหาไม่เหมาะสม หรือมีการกล่าวเท็จถึงโคโรนาไวรัส และร่วมมือกับหน่วยงานองค์การอนามัยโลก (WHO) และหน่วยงานกระทรวงสาธารณสุขของรัฐบาลในท้องถิ่น เพื่อส่งต่อข้อมูลที่ถูกต้องให้แก่ผู้ใช้ทุกคน
				</p>
				<br/>
				<p>
				ก่อนที่ท่านจะใช้งานแอปพลิเคชันได้ เราจึงต้องขอให้ท่านยอมรับเงื่อนไขการใช้งานและ / หรือนโยบายผู้ใช้ของแอปพลิเคชันก่อนทำการสร้างหรืออัปโหลดเนื้อหา
				</p>
				<br/>
				<p>
				เช่นเดียวกันกับวิธีที่เราจัดการกับเนื้อหาที่ไม่เหมาะสมในชุมชน นี่เป็นวิธีที่เราใช้จัดการกับผู้ใช้ที่ละเมิดข้อตกลง และป้องกันการแพร่กระจายของข้อมูลเท็จที่เกี่ยวข้องกับโคโรนาไวรัส
				</p>
				<br/>
				<ol>
					<li>หากสมาชิกในชุมชนของเราพยายามเผยแพร่เนื้อหาหรือโพสต์ใด ๆ (รวมถึงคำถาม คำตอบ รูปภาพ และ / หรือวิดีโอ ตลอดจน ลิงก์ หรือแฮชแท็ก) ระบบการตรวจสอบของเราจะตรวจจับเนื้อหานั้น ๆ ได้โดยอัตโนมัติ หลังจากนั้น ผู้ใช้จะได้รับข้อความแจ้งเตือนที่นำพวกเขาไปยังหน้าเว็บไซต์ขององค์การอนามัยโลก (WHO) และเว็บไซต์สาธารณสุขของรัฐบาลในท้องถิ่นทันที</li>
					<li>เราอนุญาตให้ผู้ใช้อื่น ๆ ทำเครื่องหมายเนื้อหาที่ไม่เหมาะสม เพื่อแจ้งเตือนผู้ดูแลระบบของเราผ่านทางอีเมล เพื่อตรวจสอบว่าเนื้อหาควรได้รับการอนุมัติหรือถูกกำจัด</li>
				</ol>
				<br/>
				<p>
				เนื้อหาที่ถือว่าไม่เหมาะสมเกี่ยวกับ โควิด19 มีดังนี้:
				</p>
				<br/>
				<ol>
					<li>
					การขาย PPE ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะ ชุดป้องกัน รองเท้า หน้ากาก หมวกกันน็อก แว่นตา และแว่นตาอื่น ๆ
					</li>
					<li>การขอเงินบริจาคในนามของหน่วยงาน ธุรกิจ หรือชุมชนที่ได้รับผลกระทบจากโรคระบาด โดยเราจะติดต่อสายด่วนของรัฐบาลให้เข้ามาดำเนินการช่วยเหลือผู้ใช้งานแทน</li>
					<li>เนื้อหาที่ก่อให้เกิดความเข้าใจผิด การแพร่กระจายข่าวลือ และข่าวปลอม</li>
				</ol>
				<br/>
				<h2 className='faq'>
				คำถามที่พบบ่อย (FAQ)
				</h2>
				<br/>
				<p className='point-title'>
				ใครคือผู้กำหนดว่า กฏระเบียบและข้อบังคับของชุมชน ควรมีเนื้อหาครอบคลุมด้านใดบ้าง? 
				</p>
				<br/>
				<p>
				theAsianparent คือชุมชนของผู้คนจากหลากหลายวัฒนธรรม อายุ และความเชื่อ
				</p>
				<br/>
				<p>
				เราจึงพยายามทำเข้าใจความแตกต่างทางด้านความคิดของทุกคน เพื่อให้เราสามารถสร้างชุมชนที่มีความปลอดภัย สบายใจ และเปิดกว้างทางความคิดสำหรับทุกคน
				</p>
				<br/>
				<p>
				ด้วยเหตุนี้ เราจึงได้จัดทำ กฏระเบียบและข้อบังคับของชุมชน ของพวกเราขึ้น เพื่อให้เราสามารถดูแลและปกป้องคอมมูนิตี้ของเราได้อย่างดียิ่ง ๆ ขึ้นไป
				</p>
				<br/>
				<p className='point-title'>
				ใครเป็นผู้ดูแลแพลตฟอร์มของเรา?
				</p>
				<br/>
				<p>
				สำหรับการดูแล และตรวจสอบชุมชนของเรา เรามีระบบอัตโนมัติขั้นสูง ที่สามารถตรวจจับการละเมิดกฎระเบียบและข้อบังคับภายในชุมชนของผู้ใช้งานแต่ละคนได้
				</p>
				<br/>
				<p>
				อย่างไรก็ตาม ระบบดังกล่าวนั้นอยู่ภายใต้การควบคุม ดูแลจากทีมงานของเราที่เป็นบุคคล
				</p>
				<br/>
				<p className='point-title'>
				หากฉันพบเห็นการโพสต์ การตอบกลับ หรือความคิดเห็นบนแพลตฟอร์ม theAsianparent ที่ละเมิดกฎระเบียบและข้อบังคับของชุมชน ฉันต้องทำอย่างไร?
				</p>
				<br/>
				<p>
				หากท่านเห็นผู้ใช้งานท่านอื่น ๆ ละเมิดกฎระเบียบชุมชนของเรา ท่านสามารถรายงานโพสต์ที่ละเมิดกฏเหล่านี้ได้ ด้วยการกดตัวเลือก “รายงาน” จากสัญลักษณ์จุดสามจุดที่อยู่บริเวณมุมขวาบนของโพสต์ได้เลย
				</p>
				<br/>
				<p>
				หรือท่านจะส่งอีเมลรายงานโพสต์ที่ละเมิดกฎเหล่านั้น (พร้อมหลักฐาน) มาทาง <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a> ก็ได้เช่นกัน
				</p>
				<br/>
				<p className='point-title'>
				จะเกิดอะไรขึ้นหากมีผู้ใช้งานละเมิดกฎระเบียบและข้อบังคับในชุมชนของเรา
				</p>
				<br/>
				<p>
				เรามีนโยบายในการลบเนื้อหาที่ละเมิดกฎระเบียบและข้อบังคับในชุมชนของเรา เราอาจลบโพสต์ทั้งหมดหากรูปภาพหรือข้อความนั้นมีเนื้อหาที่ละเมิดต่อกฎระเบียบและข้อบังคับในชุมชนของเรา
				</p>
				<br/>
				<p>
				และทีมงานขอสงวนสิทธิ์ในการปิดการใช้งานบัญชีผู้ใช้ที่ละเมิดกฎระเบียบและข้อบังคับของชุมชนของเรา
				</p>
				<br/>
				<p>
				และเราจะแจ้งหน่วยงานบังคับใช้กฎหมายให้เข้ามาตรวจสอบดูแล หากเราพบความเสี่ยงที่จะถูกทำร้ายร่างกายหรือพบพฤติกรรมใด ๆ ที่เสี่ยงต่อการคุกคามความปลอดภัยของสาธารณชน
				</p>
				<br/>
				<p className='point-title'>
				โพสต์/ตอบกลับ/ความคิดเห็นของฉันหายไป เกิดอะไรขึ้น?
				</p>
				<br/>
				<p>
				ปัจจุบัน theAsianparent มีระบบตรวจสอบอัตโนมัติ เพื่อช่วยในการตรวจจับโพสต์/ความคิดเห็นที่มีองค์ประกอบของรูปภาพกลั่นแกล้ง/สแปม/เหยียดเชื้อชาติ/ผิดกฎหมาย/หยาบคาย และเนื้อหาที่ไม่เหมาะสมอื่น ๆ
				</p>
				<br/>
				<p>
				ระบบตรวจสอบอัตโนมัติของเรา จะติดตามโพสต์/ความคิดเห็นตามขั้นตอนที่มีอยู่ (การลบโพสต์/ความคิดเห็น การบล็อกผู้ใช้ และอื่น ๆ)
				</p>
				<br/>
				<p>
				ทีมงานของเราจะเป็นผู้ดูแลการทำงานของระบบตรวจสอบอัตโนมัติ และจะตรวจสอบโพสต์/ความคิดเห็นที่ระบบตรวจสอบอัตโนมัติตรวจพบด้วยตัวเอง เพื่อให้เกิดความสมบูรณ์และเป็นธรรมยิ่งขึ้น
				</p>
				<br/>
				<p>
				หากโพสต์/การตอบกลับ/ความคิดเห็นไม่มีเนื้อหาที่ขัดต่อกฎระเบียบและข้อบังคับที่ได้กล่าวมาข้างต้น เราจะเปิดใช้งานโพสต์นั้น ๆ อีกครั้งภายใน 24 ชั่วโมงเวลาทำการ
				</p>
				<br/>
				<p className='point-title'>อะไรคือการโพสต์แบบไม่ระบุตัวตน</p>
				<br/>
				<p>
					จุดประสงค์ของการโพสต์แบบไม่ระบุตัวตน คือเพื่อช่วยซ่อนข้อมูลส่วนตัว ทำให้คุณพ่อคุณแม่ที่ไม่ต้องการบอกข้อมูลส่วนตัวสามารถแบ่งปันเรื่องละเอียดอ่อนได้อย่างสบายใจขึ้น
				</p>
				<br/>
				<p>
				หากคุณสังเกตเห็นการใช้งานฟีเจอร์โพสต์แบบไม่ระบุตัวตนในทางที่ผิด โปรดรายงานให้เราทราบที่ <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a> เพื่อที่ทีมงานของเราจะได้ดำเนินการตรวจสอบต่อไป
				</p>
				<br/>
				<p className='point-title'>
				ภาพถ่าย NSFW คืออะไร
				</p>
				<br/>
				<p>
				การเลือก กดที่นี่เพื่อเบลอภาพ มีจุดมุ่งหมายเพื่อป้องกันไม่ให้ผู้ใช้รายอื่น ไม่สบายใจจากการเห็นโพสต์ที่มีรูปถ่ายบางรูป
				</p>
				<br/>
				<p>
				เมื่อแนบรูปภาพในโพสต์ คุณจะพบตัวเลือก "กดที่นี่เพื่อเบลอภาพ" ที่ด้านล่างของรูปภาพ เมื่อกดแล้ว รูปภาพจะเบลอ และปรากฏคำเตือนว่า “NSFW เนื้อหาที่ส่งผลกระทบต่อจิตใจ"
				</p>			
			<br/><br/>
			<p>ปรบมือให้คุณพ่อคุณแม่ที่เลี้ยงดูลูกรักอย่างมีความสุข สุขภาพแข็งแรง เต็มไปด้วยความมั่นใจหน่อยค่ะ!!</p>
			<p className="covid-rule-title">&mdash;ทีมงาน theAsianparent</p>
			<br/><br/>
		</div>

		<div id="english" className={`tabcontent hide`}>
			<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title">
				theAsianparent Community Guidelines
				</h1>
				<br/>
			</div>
			<div className="starting-para">
				<p>
				Hi Parents! We are so excited that you can join us on your journey to parenthood!
				</p>
				<br />
				<p>
				We welcome and support moms and dads (or prospective parents) to stay in touch on our platform to share advice and stories based on personal experiences. 
				</p>
				<br />
				<p>
				However, we encourage parents not to judge each other despite differences in parenting styles, cultures, ages, beliefs, etc.
				</p>
				<br/>
				<p>
				In addition, in order to maintain security and comfort in the community, please make sure to adhere to the following guidelines:
				</p>
			</div>
			<br/>
			<p className='point-title'>
				Integrity and identity
			</p>
			<br/>
			<p>
				We do not condone impersonating a person or entity that can harm other users. 
			</p>
			<br/>
			<p>
			If there is a report of impersonation, we will confirm and ask the user to revise their profile. 
			</p>
			<br/>
			<p>
			We also do not hesitate to suspend or block the account. 
			</p>
			<br/>
			<p>
			In addition, we do not allow users to share misinformation related to: 
			</p>
			<br/>
			<ol>
				<li>Emergencies that could cause panic </li>
				<li>Incitement to hatred or prejudice against other people, certain groups, or society </li>
				<li>Medical misinformation that could harm a person's physical health</li>
				<li>Content that misleads community members about politics  </li>
				<li>Conspiracy content that attacks certain groups </li>
				<li>Violent or tragic events.</li>
			</ol>
			<br/>
			<p>
			In addition, we do not allow users to share identity that contains personal or individual privacy information. 
			</p>
			<br/>
			<p>
			We are not responsible for any losses incurred as a result of sharing personal information by users. For this reason, we also do not recommend that users share personal information in the form of:
			</p>
			<br/>
			<ol>
				<li>Place and date of birth</li>
				<li>telephone number</li>
				<li>NIK(KTP main number)</li>
				<li>Complete address of residence</li>
				<li>Photo of identification card (KTP, SIM, Family Card, Birth certificate, etc.)</li>
				<li>Certificate ownership (house certificate, land certificate, etc.)</li>
				<li>Full name of mother and father</li>
				<li>Sign in information (username and password)</li>
				<li>Debit/credit card number, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
				Inappropriate images
			</p>
			<br/>
			<p>
			As a platform for parenting and pregnancy, we really understand if you want to exchange stories related to spots/ vaginal discharge/ baby poop and so on with other users.
			</p>
			<br/>
			<p>
			Unfortunately, this may make other users feel less comfortable.
			</p>
			<br/>
			<p>
			For this reason, we do not recommend users to post sensitive images such as human/baby feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on without using <i>the tag</i> NSFW (Not Safe for Work).
			</p>
			<br/>
			<p>
			Users who post sexually explicit photos, especially children, will be removed.
			</p>
			<br/>
			<p className='point-title'>
			Spam 
			</p>
			<br/>
			<p>
			As our commitment to provide users with a good experience when interacting on our platform, we will remove any <i>spam</i> content. 
			</p>
			<br/>
			<p>
			To that end, we ask each user not to share content or engage in spammy behavior.  
			</p>
			<br/>
			<p>
			We do not support all of the following posts, responses or comments:
			</p>
			<br/>
			<ol>
				<li>Share a post/response/comment more than 2 (two) times with the same words or sentences</li>
				<li>Containing <i>spam</i> elements, such as: up, “period”, “comma”, etc.</li>
				<li>Provide comments that contain spam elements on personal or other people's posts with the aim of increasing posts to the homepage.</li>
				<li>Robotic text such as: nendifniuha3jr. 12345678, asdfghjkl, etc.</li>
				<li>Prohibitory sentence so that other users do not answer a post, such as "Posts from 1 year ago do not respond!"</li>
				<li>Linking to other websites whose security cannot be guaranteed (whatsapp group links, Facebook, Instagram, Line, etc.)</li>
			</ol>
			<br/>
			<p className='point-title'>
			Illegal activities 
			</p>
			<br/>
			<p>
			We do not support activities that violate laws and regulations. For this reason, we prohibit all activities related to criminal acts on our platform.
			</p>
			<br/>
			<p>
			We prohibit all user on the platform from participating in conversations or activities related to: 
			</p>
			<br/>
			<ol>
				<li>Exploitation of people/children</li>
				<li>Weapons</li>
				<li>Poisoning of humans</li>
				<li>Any life-threatening activities</li>
				<li>Phishing</li>
				<li>Fraud/scam/false investment</li>
				<li>Theft</li>
				<li>Spreading pornography</li>
				<li>Gambling</li>
				<li>Abortion</li>
				<li>Trafficking, promotion and use of Alcohol, Drugs, Substances and other illegal drugs.</li>
			</ol>
			<br/>
			<p className='point-title'>
			Hateful, bullying, harassment and violent behavior
			</p>
			<br/>
			<p>
			We want to create a safe and comfortable community for users. Therefore, we do not tolerate any act of discrimination against certain individuals or groups.
			</p>
			<br/>
			<p>
			Please don't share posts/ feedback/ comments: 
			</p>
			<br/>
			<ol>
				<li>Referring negatively to other Individuals as animals, inanimate objects, or in any derogatory manner </li>
				<li>Calling for or justifying any acts of violence against other individuals or groups</li>
				<li>Claims of supremacy over a group of people based on race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
				<li>Accusing or slandering certain individuals or groups as criminals</li>
				<li>Posts/ responses/ comments that use slurs or harsh words</li>
				<li>Insulting or demeaning race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
				<li>Threats to other individuals</li>
				<li>Sharing personal details of others with malicious intent or otherwise</li>
				<li>Insults and solicitation of insults towards other individuals.</li>
			</ol>
			<br/>
			<p>
			We also do not tolerate when members of our community are humiliated, bullied or harassed. Therefore, any post/response/comment that contains any expressions of violence, including threats or disparaging statements intended to ridicule, insult, humiliate, intimidate, hurt someone or words that can cause severe psychological distress will be removed from our platform.
			</p>
			<br/>
			<p>
			We also do not allow any form of posts that contain elements of sexual harassment.
			</p>
			<br/>
			<p>
			Please do not share posts/feedback/comments that contain elements of:
			</p>
			<br/>
			<ol>
				<li>Disparage other people's sexual practices</li>
				<li>Altering or morphing other people's images to display or imply sexual suggestion or involvement in sexual activities</li>
				<li>Threatening or disclosing someone's private sex life, including threats to publish digital content, sex history, names of previous sexual partners, sexual orientation, etc.</li>
				<li>Threatening or exposing the sexual orientation of others</li>
			</ol>
			<br/>
			<p>
			In addition, we also do not allow users to share posts that contain elements of violence, such as:
			</p>
			<br/>
			<ol>
				<li>Sadism/Mutilation</li>
				<li>Open wounds</li>
				<li>Accidents</li>
				<li>Corpses </li>
				<li>Mutilated, charred or burned limbs</li>
				<li>Violence</li>
				<li>Torture, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
			Suicide, self-harm and other dangerous acts
			</p>
			<br/>
			<p>
			As a <i>parenting</i> platform, we care deeply about the health and safety of our users. 
			</p>
			<br/>
			<p>
			For this reason, we do not condone any post that depicts, promotes or normalises any activity that leads to suicide, self-injury, or dangerous activities that can cause serious injury or even death. 
			</p>
			<br/>
			<p className='point-title'>
			Promotions
			</p>
			<br/>
			<p>
			We strive to provide convenience to every user of our application. For this reason, we only allow posts related to promotions, buying and selling activities or <i>giveaways</i> to be posted in the Buying and Selling <i>topic</i>.
			</p>
			<br/>
			<p>
			We will delete posts/responses/comments/ecommerce links/social media links that contain elements of promotion, buying and selling or <i>giveaways</i> outside the Buying and Selling <i>topic</i>
			</p>
			<br/>
			<p>
			We DO NOT allow the sale or administration of any drugs on our service! 
			</p>
			<br/>
			<p>
			No type of medicines may be given or sold by users on this platform.
			</p>
			<br/>
			<p>
			So, please don't share posts/responses/comments that contain:
			</p>
			<br/>
			<ol>
				<li>Suggestions for the use or administration of drugs</li>
				<li>Promotion or sale of chemicals, drugs, herbs, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
			theAsianparent Cares About Your Family's Safety from COVID-19
			</p>
			<br/>
			<p>
			Since the World Health Organisation (WHO) declared COVID-19 a pandemic in January 2020, we at theAsianparent have worked hard to keep our community safe by ensuring they have access to accurate information and limiting the spread of false information.
			</p>
			<br/>
			<p>
			Here's an overview of how we address this:
			</p>
			<br/>
			<p>
			We protect our community from those who perpetuate and spread false information.
			</p>
			<br/>
			<p>
			Our goal is to provide a safe, supportive and caring community and environment for parents during the pandemic. To address this, we actively monitor User Generated Content (UGC)*, and flag and remove any inappropriate content* that refers to viruses, provokes users about the World Health Organisation (WHO), as well as local government ministries of health.
			</p>
			<br/>
			<p>
			Before accessing the application, users are required to agree to the application's terms of use and/or user policies before creating or uploading content.
			</p>
			<br/>
			<p>
			In the same way, we deal with inappropriate content in our community.
			</p>
			<br/>
			<p>
			Here's how we deal with violators and prevent the spread of virus-related misinformation:
			</p>
			<br/>
			<ol>
				<li>If a member of our community tries to share any content or posts (including questions, responses, images and/or videos, links, hashtags) related to COVID-19, the content will automatically be detected by our system for internal moderators to look at. After that, users will also receive a notification directing them to the WHO website and the local health ministry.</li>
				<li>We allow users to flag inappropriate content, then ask our moderators to review the flagged content.</li>
			</ol>
			<br/>
			<p>
			The following is inappropriate content related to COVID-19:
			</p>
			<br/>
			<ol>
				<li>Sales of PPE, including protective clothing and footwear, masks, helmets, and goggles;</li>
				<li>Request donations on behalf of volunteers and businesses and communities affected by the pandemic - in return we will direct users to their official hotlines;</li>
				<li>Misleading content</li>
				<li>Content that involves spreading rumors and fake news.</li>
			</ol>
			<br/>
			<h2 className='faq'>Frequently Asked Questions (FAQ)</h2>
			<br/>
			<p className='point-title'>
				Who decides what the Community Guidelines should cover?
			</p>
			<br/>
			<p>
			theAsianparent is a community of people from diverse cultures, ages and beliefs.
			</p>
			<br/>
			<p>
			We have tried to understand different points of view to create a comfortable, safe and open community for everyone. 
			</p>
			<br/>
			<p>
			These Community Guidelines were created so that we can nurture and protect our community.
			</p>
			<br/>
			<p className='point-title'>
			Who moderates our platform?
			</p>
			<br/>
			<p>
			For our day-to-day moderation of the community, we are assisted by an advanced system that will detect violations of the Community Guidelines by users.
			</p>
			<br/>
			<p>
			However, our human moderators double check the system and the decisions made by it.
			</p>
			<br/>
			<p className='point-title'>
			I see that a post, response or comment on theAsianparent platform violates the Community Guidelines. What do I have to do?
			</p>
			<br/>
			<p>
			If you know another user is violating our Community Guidelines, please report them.
			</p>
			<br/>
			<p>
			You can tap the “REPORT USER” option from the menu drop-down which can be found by tapping the 3 dots (...) in the upper right corner of each post/response/comment.
			</p>
			<br/>
			<p>
			You can also email us the report (with evidence) to <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>
			</p>
			<br/>
			<p className='point-title'>
			What happens if someone violates our Community Guidelines?
			</p>
			<br/>
			<p>
			We have a policy for removing content that violates our Community Guidelines. We may remove an entire post if the associated image or text violates our Community Guidelines.
			</p>
			<br/>
			<p>
			We may also disable all accounts that violate our Community Guidelines.
			</p>
			<br/>
			<p>
			We may inform law enforcement, if we believe there is a risk of physical harm or threat to public safety.
			</p>
			<br/>
			<p className='point-title'>
			My post/response/comment suddenly disappeared, what happened?
			</p>
			<br/>
			<p>
			Currently theAsianparent has an Automatic Moderation System that can detect posts/comments that contain elements of bullying/spam/racist/illegal/vulgar photos and other inappropriate content.
			</p>
			<br/>
			<p>
			Our Automatic Moderation System will also follow up on the post/comment according to existing procedures (deleting posts/comments, blocking users, and so on).
			</p>
			<br/>
			<p>
			We will continue to monitor the Automatic Moderation System to make it even more perfect. We will also review posts/comments detected by the system.
			</p>
			<br/>
			<p>
			If the post/comment does not contain the elements mentioned above, we will reactivate it within 1x24 hours (working days).
			</p>
			<br/>
			<p className='point-title'>
			Why can users post using the Anonymous feature?
			</p>
			<br/>
			<p>
			The purpose of the anonymous feature is to help parents who want to share sensitive things that they can't tell others.
			</p>
			<br/>
			<p>
			If you notice any abuse of the anonymous feature, please report it to us at <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. We will follow up.
			</p>
			<br/>
			<p className='point-title'>
			What is an NSFW photo?
			</p>
			<br/>
			<p>
			<i>The</i> NSFW <i>tag</i> (Not Safe for Work) aims to prevent other users from being disturbed by posting certain photos.
			</p>
			<br/>
			<p>
			When attaching a photo to a post, you can find this "NSFW" checkbox at the bottom of the photo. By ticking "NSFW", the photo will be blurred and a warning will appear as an "unsafe to view" photo.
			</p>
			<br/>
			<p>
			We categorise several photos as "unsafe to view" namely female or male genitalia (be it a baby or adult), photos of fluid from female or male genitalia; nude photos (be it a baby or an adult), human/infant feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on.
			</p>
			<br/>
			<p>
			If this "vulgar" photo is not posted as NSFW, we will delete the photo and may suspend the account that uploaded it.
			</p>
			<br/><br/>
			<p>Cheers to raising happy, healthy, and confident kids!</p>
			<p className="covid-rule-title">&mdash;theAsianparent Team</p>
			<br/><br/> 
		</div>
	</Fragment>
);

const ContentIdHtml = (props) => (
	<Fragment>
		<div className="language-tabs">
			<div onClick={() => props.openTab('english', 'englishContent', 'bahasa')} id="englishContent" className="tab-label">English</div>
			<div onClick={() => props.openTab('bahasa', 'bahasaContent', 'bahasa')} id="bahasaContent" className={`tab-label tab-visited`}>Bahasa</div>
		</div>

		<div id="bahasa" className="tabcontent">
	    	<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title point-title">
				BAHASA
				</h1>
				<h2 className='point-title pedoman-text'>	
					Pedoman Komunitas theAsianparent
				</h2>
			</div>
			<div className="starting-para">
				<p>
				Hai <i>Parents</i>!
				</p>
				<br/>
				<p>
				Kami sangat senang kamu dapat bergabung dengan kami dalam perjalananmu menjadi orang tua! Kami menyambut dan mendukung para Bunda dan Ayah (dan para calon orang tua) untuk saling bersilaturahmi, berbagi saran dan bertukar cerita di <i>platform</i> kami.. 
				</p>
				<br/>
				<p>
				Namun, kami menganjurkan para orang tua untuk tidak saling menghakimi meskipun memiliki perbedaan gaya <i>parenting</i>, budaya, usia, kepercayaan, dll.
				</p>
				<br/>
				<p>
				Selain itu, agar keamanan dan kenyaman dalam komunitas tetap terjaga, harap pastikan untuk mematuhi panduan berikut ini:
				</p>
				<br/>
				<p className='point-title'>
				Integritas dan identitas
				</p>
				<br/>
				<p>
				Kami tidak membenarkan tindakan menyamar sebagai orang atau entitas yang bisa merugikan pengguna lain. 
				</p>
				<br/>
				<p>
				Jika terdapat pelaporan peniruan identitas, kami akan mengkonfirmasi serta meminta pengguna tersebut untuk merevisi profilnya.
				</p>
				<br/>
				<p>
				Kami juga tidak segan untuk menangguhkan atau memblokir akun tersebut.
				</p>
				<br/>
				<p>
				Selain itu, kami tidak membenarkan pengguna untuk membagikan misinformasi yang terkait: 
				</p>
				<br/>
				<ol>
					<li>keadaan darurat yang dapat menyebabkan kepanikan,</li>
					<li>hasutan kebencian atau prasangka negatif terhadap orang lain, kelompok tertentu, atau masyarakat,</li>
					<li>misinformasi medis yang dapat membahayakan kesehatan fisik seseorang,</li>
					<li>konten yang menyesatkan anggota komunitas mengenai politik,</li>
					<li>konten konspirasi yang menyerang kelompok tertentu,</li>
					<li>peristiwa kekerasan atau tragis.</li>
				</ol>
				<br/>
				<p>Mengenai hak-hak manusia di dalam dan di luar platform theAsianparent, kami berharap pengguna: </p>
				<br/>
				<ol>
					<li>tidak melanggar hak kekayaan intelektual orang lain, privasi, atau hak lainnya,</li>
					<li>tidak melakukan atau memposting konten apa pun yang melanggar undang-undang dan peraturan,</li>
					<li>tidak melakukan plagiarisme.</li>
				</ol>
				<br/>
				<p>
				Kami tidak memiliki tanggung jawab atas segala konsekuensi hukum yang diakibatkan oleh pelanggaran pedoman komunitas ini oleh pengguna.
				</p>
				<br/>
				<p>
				Selain itu, kami juga tidak membenarkan pengguna untuk menyebarkan identitas yang mengandung informasi privasi milik pribadi maupun individu lain. 
				</p>
				<br/>
				<p>
				Kami tidak bertanggung jawab atas kerugian yang ditimbulkan akibat dari penyebaran identitas pribadi oleh pengguna. Untuk itu, kami juga tidak menyarankan pengguna untuk membagikan identitas pribadi berupa:
				</p>
				<br/>
				<ol>
					<li>tempat dan tanggal lahir,</li>
					<li>nomor telepon,</li>
					<li>NIK (Nomor Induk KTP)</li>
					<li>alamat lengkap tempat tinggal,</li>
					<li>foto kartu tanda pengenal (KTP, SIM, Kartu Keluarga, Akta kelahiran, dsb.),</li>
					<li>surat sertifikat kepemilikan (sertifikat rumah, sertifikat tanah, dsb.),</li>
					<li>nama lengkap ibu dan bapak kandung,</li>
					<li>informasi <i>sign in</i> (<i>username</i> dan kata sandi),</li>
					<li>nomor kartu debit/ kredit, dsb.</li>
				</ol>
				<br/>
				<p className='point-title'>
				Gambar kurang pantas
				</p>
				<br/>
				<p>
					Sebagai <i>platform parenting</i> dan kehamilan, kami sangat paham jika kamu ingin bertukar cerita terkait flek/ cairan vagina/ keputihan/ kotoran bayi dan sebagainya dengan pengguna lain.
				</p>
				<br/>
				<p>
				Sayangnya, hal ini mungkin bisa membuat pengguna lain merasa kurang nyaman.
				</p>
				<br/>
				<p>
				Untuk itu, kami tidak menyarankan pengguna untuk memposting gambar sensitif seperti kotoran manusia/ bayi, popok kotor, muntah, pakaian dalam yang kotor, luka, lendir, darah, dan sebagainya tanpa menggunakan <i>tag</i> NSFW (<i>Not Safe for Work</i>).
				</p>
				<br/>
				<p>
					Pengguna yang memposting foto seksual eksplisit terutama anak-anak akan dihapus.
				</p>
				<br/>
				<p className='point-title'>
				Spam
				</p>
				<br/>
				<p>
				Sebagai komitmen kami untuk memberikan pengguna pengalaman yang baik saat berinteraksi di <i>platform</i> kami, maka kami akan menghapus setiap konten <i>spam</i>. 
				</p>
				<br/>
				<p>
				Untuk itu, kami minta setiap pengguna untuk tidak menyebarkan konten atau terlibat dalam perilaku <i>spam</i>. 
				</p>
				<br/>
				<p>
				Kami tidak mendukung semua postingan, tanggapan atau komentar berikut: 
				</p>
				<br/>
				<ol>
					<li>membagikan postingan/ tanggapan/ komentar lebih dari 2 (dua) kali dengan kata-kata atau kalimat yang sama,</li>
					<li>mengandung unsur <i>spam</i>, seperti: up, naik, “titik”, “koma”, dsb.,</li>
					<li>memberikan komentar yang mengandung unsur spam di postingan pribadi atau orang lain yang bertujuan menaikkan postingan ke beranda,</li>
					<li>teks robot seperti: nendifniuha3jr. 12345678, asdfghjkl, dsb.,</li>
					<li>kalimat larangan agar pengguna lain tidak menjawab suatu postingan, seperti “Postingan 1 tahun lalu jangan ditanggapi!”,</li>
					<li>menautkan situs web lain yang tidak dapat dijamin keamanannya (link grup Whatsapp, Facebook, Instagram, Line, dsb.).</li>
				</ol>
				<br/>
				<p className='point-title'>
				Aktivitas ilegal
				</p>
				<br/>
				<p>
				Kami tidak mendukung kegiatan melanggar hukum dan peraturan perundang-undangan yang dilakukan oleh pengguna. Untuk itu, kami melarang segala aktivitas yang berkaitan dengan tindakan kriminal di <i>platform</i> kami.
				</p>
				<br/>
				<p>
				Kami melarang setiap pengguna <i>platform</i> kami untuk memberikan dan menyebarkan kegiatan yang berhubungan dengan:
				</p>
				<br/>
				<ol>
					<li>eksploitasi manusia/ anak,</li>
					<li>senjata,</li>
					<li>meracuni manusia,</li>
					<li>segala kegiatan yang mengancam nyawa,</li>
					<li>phishing,</li>
					<li>penipuan/ scam/ investasi palsu,</li>
					<li>pencurian,</li>
					<li>penyebaran pornografi,</li>
					<li>perjudian,</li>
					<li>pengguguran kandungan,</li>
					<li>perdagangan, promosi, dan penggunaan Alkohol, Narkoba, Zat dan Obat-obatan terlarang lainnya.</li>
				</ol>
				<br/>
				<p className='point-title'>
				Perilaku kebencian, perundungan, pelecehan, dan kekerasan
				</p>
				<br/>
				<p>
				Kami ingin menciptakan komunitas yang aman dan nyaman bagi pengguna. Maka dari itu, kami tidak mentoleransi segala tindakan diskriminasi terhadap individu atau kelompok tertentu. 
				</p>
				<br/>
				<p>
				Harap tidak membagikan postingan/ tanggapan/ komentar:
				</p>
				<br/>
				<ol>
					<li>merujuk Individu lain secara negatif sebagai hewan, benda mati, atau entitas bukan manusia lainnya,</li>
					<li>mengajak melakukan atau membenarkan segala tindakan kekerasan terhadap individu atau kelompok tertentu,</li>
					<li>klaim supremasi atas sekelompok orang terkait dengan ras, etnis, agama, asal kebangsaan, penyakit serius, disabilitas, dsb.,</li>
					<li>menuduh atau memfitnah individu atau kelompok tertentu adalah penjahat,</li>
					<li>postingan/ tanggapan/ komentar yang menggunakan cercaan atau kata kasar,</li>
					<li>menghina atau merendahkan ras, etnis, agama, asal kebangsaan, penyakit serius, disabilitas, dsb.,</li>
					<li>ancaman terhadap individu lain,</li>
					<li>penyebaran data pribadi milik individu lain dengan tujuan buruk,</li>
					<li>hinaan dan ajakan untuk menghina individu lain.</li>
				</ol>
				<br/>
				<p>
				Kami juga tidak menoleransi jika anggota komunitas kami dipermalukan, dirundung, atau dilecehkan. 
				</p>
				<br/>
				<p>
				Oleh karena itu, setiap postingan/ tanggapan/ komentar yang memuat semua ekspresi kekerasan, termasuk ancaman atau pernyataan meremehkan yang dimaksudkan untuk mencemooh, menghina, mempermalukan, mengintimidasi, menyakiti seseorang atau perkataan yang dapat menyebabkan tekanan psikologis berat dan akan dihapus dari <i>platform</i> kami. 
				</p>
				<br/>
				<p>
				Kami juga sangat tidak mengizinkan segala bentuk postingan yang memuat unsur pelecehan seksual.
				</p>
				<br/>
				<p>
				Harap untuk tidak membagikan postingan/ tanggapan/ komentar yang memuat unsur:
				</p>
				<br/>
				<ol>
					<li>meremehkan kegiatan seksual orang lain,</li>
					<li>mengubah atau mentransformasi gambar orang lain untuk menampilkan atau menyiratkan sugesti seksual atau keterlibatan dalam kegiatan seksual,</li>
					<li>mengancam atau mengungkapkan kehidupan seks pribadi seseorang, termasuk ancaman untuk mempublikasikan konten digital, riwayat seks, nama pasangan seksual sebelumnya, orientasi seksual, dsb.,</li>
					<li>mengancam atau mengekspos orientasi seksual orang lain.</li>
				</ol>
				<br/>
				<p>
				Selain itu, kami juga tidak membenarkan pengguna untuk melakukan dan menyebarkan postingan yang mengandung unsur kekerasan, seperti:
				</p>
				<br/>
				<ol>
					<li>kesadisan,</li>
					<li>luka terbuka,</li>
					<li>kecelakaan,</li>
					<li>mayat,</li>
					<li>anggota tubuh yang dimutilasi, hangus atau terbakar,</li>
					<li>kekerasan,</li>
					<li>penyiksaan, dll.</li>
				</ol>
				<br/>
				<p  className='point-title'>
				Bunuh diri, mencelakai diri sendiri, dan tindakan berbahaya lainnya
				</p>
				<br/>
				<p>
				Sebagai <i>platform parenting</i>, kami sangat peduli akan kesehatan dan keamanan pengguna.
				</p>
				<br/>
				<p>
				Untuk itu, kami tidak membenarkan segala postingan yang menggambarkan, mempromosikan atau menganggap normal segala aktivitas yang mengarah kepada  tindakan bunuh diri, mencederai diri sendiri, atau kegiatan berbahaya yang dapat menyebabkan cedera serius bahkan kematian. 
				</p>
				<br/>
				<p  className='point-title'>
				Promosi
				</p>
				<br/>
				<p>
				Kami berusaha memberikan kenyamanan pada setiap pengguna aplikasi kami. Untuk itu, kami hanya mengizinkan postingan terkait promosi, kegiatan jual-beli atau giveaway hanya diposting di topik Jual-Beli. 
				</p>
				<br/>
				<p>
				Kami akan menghapus postingan/ tanggapan/ komentar/ link e-commerce/ link sosial media yang memuat unsur promosi, jual-beli atau <i>giveaway</i> di luar topik Jual-Beli.
				</p>
				<br/>
				<p>
				Kami TIDAK mengizinkan penjualan atau pemberian obat apa pun di <i>platform</i> kami! 
				</p>
				<br/>
				<p>
				Semua jenis obat-obatan tidak boleh diberikan atau dijual oleh pengguna di <i>platform</i> ini.
				</p>
				<br/>
				<p>
				Jadi, harap untuk tidak membagikan postingan/ tanggapan/ komentar yang berisi:
				</p>
				<br/>
				<ol>
					<li>Saran penggunaan atau pemberian obat </li>
					<li>Promosi atau penjualan zat kimia, obat, jamu, dsb.</li>
				</ol>
				<br/>
				<p  className='point-title'>
				theAsianparent Peduli Dengan Keamanan Keluarga Anda dari COVID-19
				</p>
				<br/>
				<p>
				Sejak Organisasi Kesehatan Dunia (WHO) menyatakan COVID-19 sebagai pandemi pada Januari 2020, kami di theAsianparent telah bekerja keras untuk menjaga komunitas kami aman dengan memastikan mereka memiliki akses ke informasi yang akurat dan membatasi penyebaran informasi palsu.
				</p>
				<br/>
				<p>
				Berikut gambaran umum tentang bagaimana kami mengatasi hal ini:
				</p>
				<br/>
				<p>
				Kami melindungi komunitas kami dari mereka yang mengabadikan dan menyebarkan informasi palsu.
				</p>
				<br/>
				<p>
				Tujuan kami adalah untuk menyediakan komunitas dan lingkungan yang aman, suportif, dan peduli kepada orang tua selama pandemi. Untuk mengatasi hal ini, kami secara aktif mengawasi Konten Pengguna (UGC)*, dan menandai serta menghapus konten apa pun yang tidak pantas* yang merujuk pada virus, memprovokasi pengguna tentang organisasi kesehatan global (WHO), serta pemerintah kementerian kesehatan lokal.
				</p>
				<br/>
				<p>
				Sebelum mengakses aplikasi, pengguna diharuskan untuk menyetujui persyaratan penggunaan aplikasi dan/ atau kebijakan pengguna sebelum membuat atau mengunggah konten.
				</p>
				<br/>
				<p>
				Dengan cara yang sama, kami menangani konten yang tidak pantas di komunitas kami. 
				</p>
				<br/>
				<p>
				Berikut inilah cara kami menangani pelanggar dan mencegah penyebaran informasi palsu terkait virus:
				</p>
				<br/>
				<ol>
					<li>Jika anggota komunitas kami mencoba untuk membagikan konten atau postingan apa pun (termasuk pertanyaan, tanggapan, gambar dan/ atau video, tautan, tagar) yang terkait dengan COVID-19, konten itu secara otomatis akan terdeteksi oleh sistem dan moderator internal kami. Selanjutnya, sistem dan moderator kami akan mencegah pengguna aplikasi untuk mempostingnya. Setelah itu, pengguna juga akan menerima pemberitahuan yang mengarahkan mereka ke situs web WHO dan menteri kesehatan lokal.</li>
					<li>Kami mengizinkan pengguna untuk menandai konten yang tidak pantas, selanjutnya meminta moderator kami meninjau konten yang ditandai</li>
				</ol>
				<br/>
				<p>
				Berikut adalah konten yang tidak pantas terkait COVID-19:
				</p>
				<br/>
				<ol>
					<li>Penjualan APD, termasuk pada pakaian pelindung dan alas kaki, masker, helm, dan goggle;</li>
					<li>Meminta sumbangan atas nama sukarelawan dan bisnis serta komunitas yang terkena dampak pandemi - sebagai gantinya kami akan mengarahkan pengguna ke hotline resmi mereka;</li>
					<li>Konten yang menyesatkan</li>
					<li>Konten yang melibatkan penyebaran rumor dan berita palsu</li>
				</ol>
				<br/>
				<h2 className='faq'>Frequently Asked Questions (FAQ)</h2>
				<br/>
				<p className='point-title'>
				Siapa yang memutuskan hal yang harus dicakup oleh Pedoman Komunitas?
				</p>
				<br/>
				<p>
				theAsianparent merupakan komunitas dengan anggota yang beragam dari budaya, usia, dan kepercayaan. 
				</p>
				<br/>
				<p>
				Kami telah mencoba memahami berbagai sudut pandang untuk menciptakan komunitas yang nyaman, aman dan terbuka untuk semua orang. 
				</p>
				<br/>
				<p>
				Pedoman Komunitas ini dibuat agar kami dapat membina dan melindungi komunitas kami.
				</p>
				<br/>
				<p  className='point-title'>
					Siapa yang melakukan moderasi di <i>platform</i> kami?
				</p>
				<br/>
				<p>
				Sehari-hari dalam memoderasi komunitas, kami dibantu oleh sistem canggih yang akan mendeteksi pelanggaran Pedoman Komunitas oleh pengguna. 
				</p>
				<br/>
				<p>
				Namun, moderator kami (Minsay) akan tetap ikut meninjau (double check) setiap keputusan yang diambil oleh sistem canggih ini.
				</p>
				<br/>
				<p className='point-title'>
				Saya melihat postingan, tanggapan atau komentar di platform theAsianparent melanggar Pedoman Komunitas. Apa yang harus saya lakukan?
				</p>
				<br/>
				<p>
				Jika kamu mengetahui pengguna lain melanggar Pedoman Komunitas, silakan untuk melaporkannya. 
				</p>
				<br/>
				<p>
				Kamu bisa mengetuk opsi “LAPORKAN PENGGUNA” dari menu <i>drop-down</i> yang dapat ditemukan dengan mengetuk 3 (tiga) titik di sudut kanan atas setiap postingan/ tanggapan/ komentar. 
				</p>
				<br/>
				<p>
				Kamu juga dapat mengirim email laporan (disertai bukti) kepada kami ke <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. 
				</p>
				<br/>
				<p className='point-title'>
				Apa yang terjadi jika seseorang melanggar Pedoman Komunitas?
				</p>
				<br/>
				<p>
				Kami memiliki kebijakan untuk menghapus konten yang melanggar Pedoman Komunitas. Kami dapat menghapus seluruh postingan jika gambar atau teks terkait melanggar Pedoman Komunitas kami.
				</p>
				<br/>
				<p>
				Kami juga dapat menonaktifkan seluruh akun yang melanggar Pedoman Komunitas kami.
				</p>
				<br/>
				<p>
				Kami dapat bekerja sama dengan penegak hukum, termasuk ketika kami yakin bahwa ada risiko bahaya fisik atau ancaman terhadap keselamatan publik. 
				</p>	
				<br/>
				<p className='point-title'>
				Postingan/ tanggapan/ komentar saya tiba-tiba hilang, apa yang terjadi?
				</p>
				<br/>
				<p>
				Saat ini theAsianparent memiliki Sistem Moderasi Otomatis yang dapat mendeteksi postingan/komentar yang mengandung unsur <i>bullying/spam/rasis/ilegal/foto</i> vulgar dan konten kurang pantas lainnya.
				</p>
				<br/>
				<p>
				Sistem Moderasi Otomatis kami juga akan menindaklanjuti postingan/komentar tersebut sesuai dengan prosedur yang ada (menghapus postingan/komentar, memblokir pengguna, dan lain sebagainya).
				</p>
				<br/>
				<p>
				Kami akan terus mengawasi Sistem Moderasi Otomatis agar sistem ini semakin sempurna. Kami juga akan ikut meninjau postingan/komentar yang terdeteksi oleh sistem. 
				</p>
				<br/>
				<p>
				Jika postingan/komentar tidak mengandung unsur yang disebutkan di atas, kami akan mengaktifkannya kembali dalam kurun waktu 1x24 jam (hari kerja).
				</p>
				<br/>
				<p className='point-title'>
				Kenapa pengguna bisa memposting secara Anonim?
				</p>
				<br/>
				<p>
				Tujuan fitur Anonim adalah untuk membantu pengguna yang ingin bercerita hal sensitif yang tidak bisa ia ceritakan pada orang lain. 
				</p>
				<br/>
				<p>
				Jika kamu melihat adanya penyalahgunaan fitur anonim, silakan laporkan hal ini kepada kami ke <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. Kami akan menindaklanjutinya.
				</p>
				<br/>
				<p className='point-title'>
				Apa itu NSFW foto?
				</p>
				<br/>
				<p>
				<i>Tag</i> NSFW (Not Safe for Work) bertujuan supaya pengguna lain tidak merasa terganggu dengan postingan foto tertentu.
				</p>
				<br/>
				<p>
				Saat melampirkan foto di setiap postingan, kamu bisa menemukan ceklis "NSFW" ini di bagian bawah foto. Dengan menceklis "NSFW", foto tersebut akan diblurkan dan muncul peringatan sebagai foto "tidak aman untuk dilihat".
				</p>
				<br/>
				<p>
				Kami mengkategorikan beberapa foto "tidak aman untuk dilihat" yaitu alat kelamin wanita atau pria (baik itu masih bayi atau dewasa), foto cairan dari alat kelamin wanita atau pria; foto tanpa busana (baik itu masih bayi atau dewasa), kotoran manusia/ bayi, popok kotor, muntah, pakaian dalam yang kotor, luka, lendir, darah, dan sebagainya.
				</p>
				<br/>
				<p>
					Jika foto "vulgar" ini tidak diposting sebagai NSFW, kami akan menghapus foto itu dan mungkin akan menangguhkan akun yang mengunggahnya.
				</p>
				<br/><br/>
				<p>Ayo, semangat dalam membesarkan anak-anak yang bahagia, sehat, dan percaya diri!</p>
				<p className="covid-rule-title">&mdash;Tim theAsianparent</p>
				<br/><br/>



			</div>
				
		</div>

		<div id="english" className={`tabcontent hide`}>
			<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title">
				theAsianparent Community Guidelines
				</h1>
				<br/>
			</div>
			<div className="starting-para">
				<p>
				Hi Parents! We are so excited that you can join us on your journey to parenthood!
				</p>
				<br />
				<p>
				We welcome and support moms and dads (or prospective parents) to stay in touch on our platform to share advice and stories based on personal experiences. 
				</p>
				<br />
				<p>
				However, we encourage parents not to judge each other despite differences in parenting styles, cultures, ages, beliefs, etc.
				</p>
				<br/>
				<p>
				In addition, in order to maintain security and comfort in the community, please make sure to adhere to the following guidelines:
				</p>
			</div>
			<br/>
			<p className='point-title'>
				Integrity and identity
			</p>
			<br/>
			<p>
				We do not condone impersonating a person or entity that can harm other users. 
			</p>
			<br/>
			<p>
			If there is a report of impersonation, we will confirm and ask the user to revise their profile. 
			</p>
			<br/>
			<p>
			We also do not hesitate to suspend or block the account. 
			</p>
			<br/>
			<p>
			In addition, we do not allow users to share misinformation related to: 
			</p>
			<br/>
			<ol>
				<li>Emergencies that could cause panic </li>
				<li>Incitement to hatred or prejudice against other people, certain groups, or society </li>
				<li>Medical misinformation that could harm a person's physical health</li>
				<li>Content that misleads community members about politics  </li>
				<li>Conspiracy content that attacks certain groups </li>
				<li>Violent or tragic events.</li>
			</ol>
			<br/>
			<p>
			In addition, we do not allow users to share identity that contains personal or individual privacy information. 
			</p>
			<br/>
			<p>
			We are not responsible for any losses incurred as a result of sharing personal information by users. For this reason, we also do not recommend that users share personal information in the form of:
			</p>
			<br/>
			<ol>
				<li>Place and date of birth</li>
				<li>telephone number</li>
				<li>NIK(KTP main number)</li>
				<li>Complete address of residence</li>
				<li>Photo of identification card (KTP, SIM, Family Card, Birth certificate, etc.)</li>
				<li>Certificate ownership (house certificate, land certificate, etc.)</li>
				<li>Full name of mother and father</li>
				<li>Sign in information (username and password)</li>
				<li>Debit/credit card number, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
				Inappropriate images
			</p>
			<br/>
			<p>
			As a platform for parenting and pregnancy, we really understand if you want to exchange stories related to spots/ vaginal discharge/ baby poop and so on with other users.
			</p>
			<br/>
			<p>
			Unfortunately, this may make other users feel less comfortable.
			</p>
			<br/>
			<p>
			For this reason, we do not recommend users to post sensitive images such as human/baby feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on without using <i>the tag</i> NSFW (Not Safe for Work).
			</p>
			<br/>
			<p>
			Users who post sexually explicit photos, especially children, will be removed.
			</p>
			<br/>
			<p className='point-title'>
			Spam 
			</p>
			<br/>
			<p>
			As our commitment to provide users with a good experience when interacting on our platform, we will remove any <i>spam</i> content. 
			</p>
			<br/>
			<p>
			To that end, we ask each user not to share content or engage in spammy behavior.  
			</p>
			<br/>
			<p>
			We do not support all of the following posts, responses or comments:
			</p>
			<br/>
			<ol>
				<li>Share a post/response/comment more than 2 (two) times with the same words or sentences</li>
				<li>Containing <i>spam</i> elements, such as: up, “period”, “comma”, etc.</li>
				<li>Provide comments that contain spam elements on personal or other people's posts with the aim of increasing posts to the homepage.</li>
				<li>Robotic text such as: nendifniuha3jr. 12345678, asdfghjkl, etc.</li>
				<li>Prohibitory sentence so that other users do not answer a post, such as "Posts from 1 year ago do not respond!"</li>
				<li>Linking to other websites whose security cannot be guaranteed (whatsapp group links, Facebook, Instagram, Line, etc.)</li>
			</ol>
			<br/>
			<p className='point-title'>
			Illegal activities 
			</p>
			<br/>
			<p>
			We do not support activities that violate laws and regulations. For this reason, we prohibit all activities related to criminal acts on our platform.
			</p>
			<br/>
			<p>
			We prohibit all user on the platform from participating in conversations or activities related to: 
			</p>
			<br/>
			<ol>
				<li>Exploitation of people/children</li>
				<li>Weapons</li>
				<li>Poisoning of humans</li>
				<li>Any life-threatening activities</li>
				<li>Phishing</li>
				<li>Fraud/scam/false investment</li>
				<li>Theft</li>
				<li>Spreading pornography</li>
				<li>Gambling</li>
				<li>Abortion</li>
				<li>Trafficking, promotion and use of Alcohol, Drugs, Substances and other illegal drugs.</li>
			</ol>
			<br/>
			<p className='point-title'>
			Hateful, bullying, harassment and violent behavior
			</p>
			<br/>
			<p>
			We want to create a safe and comfortable community for users. Therefore, we do not tolerate any act of discrimination against certain individuals or groups.
			</p>
			<br/>
			<p>
			Please don't share posts/ feedback/ comments: 
			</p>
			<br/>
			<ol>
				<li>Referring negatively to other Individuals as animals, inanimate objects, or in any derogatory manner </li>
				<li>Calling for or justifying any acts of violence against other individuals or groups</li>
				<li>Claims of supremacy over a group of people based on race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
				<li>Accusing or slandering certain individuals or groups as criminals</li>
				<li>Posts/ responses/ comments that use slurs or harsh words</li>
				<li>Insulting or demeaning race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
				<li>Threats to other individuals</li>
				<li>Sharing personal details of others with malicious intent or otherwise</li>
				<li>Insults and solicitation of insults towards other individuals.</li>
			</ol>
			<br/>
			<p>
			We also do not tolerate when members of our community are humiliated, bullied or harassed. Therefore, any post/response/comment that contains any expressions of violence, including threats or disparaging statements intended to ridicule, insult, humiliate, intimidate, hurt someone or words that can cause severe psychological distress will be removed from our platform.
			</p>
			<br/>
			<p>
			We also do not allow any form of posts that contain elements of sexual harassment.
			</p>
			<br/>
			<p>
			Please do not share posts/feedback/comments that contain elements of:
			</p>
			<br/>
			<ol>
				<li>Disparage other people's sexual practices</li>
				<li>Altering or morphing other people's images to display or imply sexual suggestion or involvement in sexual activities</li>
				<li>Threatening or disclosing someone's private sex life, including threats to publish digital content, sex history, names of previous sexual partners, sexual orientation, etc.</li>
				<li>Threatening or exposing the sexual orientation of others</li>
			</ol>
			<br/>
			<p>
			In addition, we also do not allow users to share posts that contain elements of violence, such as:
			</p>
			<br/>
			<ol>
				<li>Sadism/Mutilation</li>
				<li>Open wounds</li>
				<li>Accidents</li>
				<li>Corpses </li>
				<li>Mutilated, charred or burned limbs</li>
				<li>Violence</li>
				<li>Torture, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
			Suicide, self-harm and other dangerous acts
			</p>
			<br/>
			<p>
			As a <i>parenting</i> platform, we care deeply about the health and safety of our users. 
			</p>
			<br/>
			<p>
			For this reason, we do not condone any post that depicts, promotes or normalises any activity that leads to suicide, self-injury, or dangerous activities that can cause serious injury or even death. 
			</p>
			<br/>
			<p className='point-title'>
			Promotions
			</p>
			<br/>
			<p>
			We strive to provide convenience to every user of our application. For this reason, we only allow posts related to promotions, buying and selling activities or <i>giveaways</i> to be posted in the Buying and Selling <i>topic</i>.
			</p>
			<br/>
			<p>
			We will delete posts/responses/comments/ecommerce links/social media links that contain elements of promotion, buying and selling or <i>giveaways</i> outside the Buying and Selling <i>topic</i>
			</p>
			<br/>
			<p>
			We DO NOT allow the sale or administration of any drugs on our service! 
			</p>
			<br/>
			<p>
			No type of medicines may be given or sold by users on this platform.
			</p>
			<br/>
			<p>
			So, please don't share posts/responses/comments that contain:
			</p>
			<br/>
			<ol>
				<li>Suggestions for the use or administration of drugs</li>
				<li>Promotion or sale of chemicals, drugs, herbs, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
			theAsianparent Cares About Your Family's Safety from COVID-19
			</p>
			<br/>
			<p>
			Since the World Health Organisation (WHO) declared COVID-19 a pandemic in January 2020, we at theAsianparent have worked hard to keep our community safe by ensuring they have access to accurate information and limiting the spread of false information.
			</p>
			<br/>
			<p>
			Here's an overview of how we address this:
			</p>
			<br/>
			<p>
			We protect our community from those who perpetuate and spread false information.
			</p>
			<br/>
			<p>
			Our goal is to provide a safe, supportive and caring community and environment for parents during the pandemic. To address this, we actively monitor User Generated Content (UGC)*, and flag and remove any inappropriate content* that refers to viruses, provokes users about the World Health Organisation (WHO), as well as local government ministries of health.
			</p>
			<br/>
			<p>
			Before accessing the application, users are required to agree to the application's terms of use and/or user policies before creating or uploading content.
			</p>
			<br/>
			<p>
			In the same way, we deal with inappropriate content in our community.
			</p>
			<br/>
			<p>
			Here's how we deal with violators and prevent the spread of virus-related misinformation:
			</p>
			<br/>
			<ol>
				<li>If a member of our community tries to share any content or posts (including questions, responses, images and/or videos, links, hashtags) related to COVID-19, the content will automatically be detected by our system for internal moderators to look at. After that, users will also receive a notification directing them to the WHO website and the local health ministry.</li>
				<li>We allow users to flag inappropriate content, then ask our moderators to review the flagged content.</li>
			</ol>
			<br/>
			<p>
			The following is inappropriate content related to COVID-19:
			</p>
			<br/>
			<ol>
				<li>Sales of PPE, including protective clothing and footwear, masks, helmets, and goggles;</li>
				<li>Request donations on behalf of volunteers and businesses and communities affected by the pandemic - in return we will direct users to their official hotlines;</li>
				<li>Misleading content</li>
				<li>Content that involves spreading rumors and fake news.</li>
			</ol>
			<br/>
			<h2 className='faq'>Frequently Asked Questions (FAQ)</h2>
			<br/>
			<p className='point-title'>
				Who decides what the Community Guidelines should cover?
			</p>
			<br/>
			<p>
			theAsianparent is a community of people from diverse cultures, ages and beliefs.
			</p>
			<br/>
			<p>
			We have tried to understand different points of view to create a comfortable, safe and open community for everyone. 
			</p>
			<br/>
			<p>
			These Community Guidelines were created so that we can nurture and protect our community.
			</p>
			<br/>
			<p className='point-title'>
			Who moderates our platform?
			</p>
			<br/>
			<p>
			For our day-to-day moderation of the community, we are assisted by an advanced system that will detect violations of the Community Guidelines by users.
			</p>
			<br/>
			<p>
			However, our human moderators double check the system and the decisions made by it.
			</p>
			<br/>
			<p className='point-title'>
			I see that a post, response or comment on theAsianparent platform violates the Community Guidelines. What do I have to do?
			</p>
			<br/>
			<p>
			If you know another user is violating our Community Guidelines, please report them.
			</p>
			<br/>
			<p>
			You can tap the “REPORT USER” option from the menu drop-down which can be found by tapping the 3 dots (...) in the upper right corner of each post/response/comment.
			</p>
			<br/>
			<p>
			You can also email us the report (with evidence) to <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>
			</p>
			<br/>
			<p className='point-title'>
			What happens if someone violates our Community Guidelines?
			</p>
			<br/>
			<p>
			We have a policy for removing content that violates our Community Guidelines. We may remove an entire post if the associated image or text violates our Community Guidelines.
			</p>
			<br/>
			<p>
			We may also disable all accounts that violate our Community Guidelines.
			</p>
			<br/>
			<p>
			We may inform law enforcement, if we believe there is a risk of physical harm or threat to public safety.
			</p>
			<br/>
			<p className='point-title'>
			My post/response/comment suddenly disappeared, what happened?
			</p>
			<br/>
			<p>
			Currently theAsianparent has an Automatic Moderation System that can detect posts/comments that contain elements of bullying/spam/racist/illegal/vulgar photos and other inappropriate content.
			</p>
			<br/>
			<p>
			Our Automatic Moderation System will also follow up on the post/comment according to existing procedures (deleting posts/comments, blocking users, and so on).
			</p>
			<br/>
			<p>
			We will continue to monitor the Automatic Moderation System to make it even more perfect. We will also review posts/comments detected by the system.
			</p>
			<br/>
			<p>
			If the post/comment does not contain the elements mentioned above, we will reactivate it within 1x24 hours (working days).
			</p>
			<br/>
			<p className='point-title'>
			Why can users post using the Anonymous feature?
			</p>
			<br/>
			<p>
			The purpose of the anonymous feature is to help parents who want to share sensitive things that they can't tell others.
			</p>
			<br/>
			<p>
			If you notice any abuse of the anonymous feature, please report it to us at <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. We will follow up.
			</p>
			<br/>
			<p className='point-title'>
			What is an NSFW photo?
			</p>
			<br/>
			<p>
			<i>The</i> NSFW <i>tag</i> (Not Safe for Work) aims to prevent other users from being disturbed by posting certain photos.
			</p>
			<br/>
			<p>
			When attaching a photo to a post, you can find this "NSFW" checkbox at the bottom of the photo. By ticking "NSFW", the photo will be blurred and a warning will appear as an "unsafe to view" photo.
			</p>
			<br/>
			<p>
			We categorise several photos as "unsafe to view" namely female or male genitalia (be it a baby or adult), photos of fluid from female or male genitalia; nude photos (be it a baby or an adult), human/infant feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on.
			</p>
			<br/>
			<p>
			If this "vulgar" photo is not posted as NSFW, we will delete the photo and may suspend the account that uploaded it.
			</p>
			<br/><br/>
			<p>Cheers to raising happy, healthy, and confident kids!</p>
			<p className="covid-rule-title">&mdash;theAsianparent Team</p>
			<br/><br/> 
		</div>
	</Fragment>
)

const ContentVnHtml = () => (
    <Fragment>		
		<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title">
					Nguyên tắc hướng dẫn dành cho cộng đồng theAsianparent
				</h1>
		</div>
		<br/>

		<div className="starting-para">
			<p>
			Chào các bậc phụ huynh! Chúng tôi vô cùng hào hứng khi bạn tham gia vào hành trình làm cha mẹ cùng theAsianparent Vietnam!
			</p>
			<br/>
			<p>
			Chúng tôi vô cùng hoan nghênh và mong muốn hỗ trợ các ông bố, những bà mẹ (hoặc các bậc phụ huynh trong tương lai) giữ vững kết nối với nền tảng của chúng tôi để có thể chia sẻ những lời khuyên và câu chuyện dựa trên kinh nghiệm cá nhân của các bạn.
			</p>
			<br/>
			<p>
			Tuy nhiên, chúng tôi khuyến khích các bậc cha mẹ không nên đánh giá, phán xét nhau bất kể sự khác biệt về cách nuôi dạy con cái, văn hóa, lứa tuổi, tín ngưỡng, v.v.
			</p>
			<br/>
			<p>
			Ngoài ra, để duy trì an ninh và sự thoải mái trong cộng đồng, hãy đảm bảo tuân thủ các nguyên tắc sau:
			</p>
		</div>
		<br/>
		<p className='point-title'>
		Liêm chính và danh tính cá nhân
		</p>
		<br/>
		<p>
		Chúng tôi không chấp nhận việc mạo danh một cá nhân hoặc tổ chức có thể gây hại cho những người dùng khác.
		</p>
		<br/>
		<p>
		Nếu có báo cáo về việc mạo danh, chúng tôi sẽ xác nhận và yêu cầu người dùng chỉnh sửa hồ sơ của họ.
		</p>
		<br/>
		<p>
		Chúng tôi cũng không ngần ngại tạm ngưng hoặc khóa bất kỳ tài khoản nào.
		</p>
		<br/>
		<p>
		Ngoài ra, chúng tôi không cho phép người dùng chia sẻ thông tin sai lệch có liên quan đến:
		</p>
		<br/>
		<ol>
			<li>Các trường hợp khẩn cấp có thể gây hoảng loạn</li>
			<li>Kích động thù hận hoặc có thành kiến ​​đối với người khác, một số nhóm hoặc xã hội</li>
			<li>Thông tin y tế sai lệch có thể gây hại đối với sức khỏe thể chất cho một người</li>
			<li>Nội dung đánh lừa các thành viên trong cộng đồng về chính trị</li>
			<li>Nội dung mang âm mưu tấn công một số nhóm người nhất định.</li>
			<li>Sự kiện bạo lực hoặc bi thảm.</li>
		</ol>
		<br/>
		<p>Ngoài ra, chúng tôi không cho phép người dùng chia sẻ danh tính có chứa thông tin cá nhân riêng tư.</p>
		<br/>
		<p>
		Chúng tôi không chịu trách nhiệm về mọi tổn thất gây ra do người dùng chia sẻ thông tin cá nhân. Vì lý do này, chúng tôi khuyến nghị người dùng không nên chia sẻ thông tin cá nhân dưới các hình thức sau đây:
		</p>
		<br/>
		<ol>
			<li>Nơi sinh và ngày sinh</li>
			<li>Số điện thoại</li>
			<li>Số CMND</li>
			<li>Địa chỉ cư trú đầy đủ</li>
			<li>Ảnh chụp các loại giấy tờ chứng minh danh tính (CMND, Thẻ sim, Sổ hộ khẩu, Giấy khai sinh, v.v.)</li>
			<li>Giấy chứng nhận quyền sở hữu (giấy chứng nhận nhà, giấy chứng nhận đất đai, v.v.)</li>
			<li>Họ và tên của mẹ và bố</li>
			<li>Thông tin đăng nhập (tên người dùng và mật khẩu)</li>
			<li>Số thẻ ghi nợ / tín dụng, v.v.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Hình ảnh không phù hợp
		</p>
		<br/>
		<p>
		theAsianparent là một nền tảng dành cho việc nuôi dạy con cái và mang thai, chúng tôi thực sự hiểu rằng việc bạn muốn trao đổi những câu chuyện liên quan đến đốm/dịch tiết âm đạo/phân em bé, v.v. với mọi người.
		</p>
		<br/>
		<p>
		Thật không may, điều này có thể khiến một số người dùng khác cảm thấy không thoải mái.
		</p>
		<br/>
		<p>
		Vì lý do này, chúng tôi không khuyến khích người dùng đăng các hình ảnh nhạy cảm như phân người/em bé, tã bẩn, chất nôn, đồ lót bẩn, vết thương, chất nhầy, máu, v.v. mà không sử dụng tag NSFW (Cảnh báo nội dung nhạy cảm).
		</p>
		<br/>
		<p>
		Người dùng đăng ảnh khiêu dâm, đặc biệt là trẻ em sẽ bị xóa.
		</p>
		<br/>
		<p className='point-title'>
		Spam
		</p>
		<br/>
		<p>
		Như cam kết cung cấp cho người dùng một trải nghiệm tuyệt vời khi tương tác trên nền tảng của chúng tôi, chúng tôi sẽ xóa mọi nội dung spam.
		</p>
		<br/>
		<p>
		Vì vậy, chúng tôi yêu cầu mỗi người dùng không chia sẻ nội dung hoặc tham gia vào các hành vi spam.
		</p>
		<br/>
		<p>
		Chúng tôi không hỗ trợ tất cả các bài đăng, phản hồi hoặc nhận xét sau:
		</p>
		<br/>
		<ol>
			<li>Chia sẻ một bài đăng / phản hồi / nhận xét nhiều hơn 2 (hai) lần với các từ hoặc câu giống nhau</li>
			<li>Chứa các yếu tố spam, chẳng hạn như: lên, “dấu chấm”, “dấu phẩy”, v.v.</li>
			<li>Đưa ra các bình luận có chứa yếu tố spam trên bài viết của cá nhân hoặc của người khác với mục đích đẩy bài đăng lên trang chủ.</li>
			<li>Văn bản rô bốt chẳng hạn như: nandini 3jr, 12345678, asdfghjkl, v.v.</li>
			<li>Câu cấm để người dùng khác không trả lời một bài đăng, chẳng hạn như "Bài viết từ 1 năm trước không phản hồi!"</li>
			<li>Liên kết đến các trang web khác không được đảm bảo bảo mật (liên kết nhóm whatsapp, Facebook, Instagram, Line, v.v.)</li>
		</ol>
		<br/>
		<p className='point-title'>
		Các hoạt động bất hợp pháp
		</p>
		<br/>
		<p>
		Chúng tôi không hỗ trợ các hoạt động vi phạm quy định và pháp luật. Vì lý do này, chúng tôi nghiêm cấm tất cả các hoạt động liên quan đến hành vi phạm tội trên nền tảng.
		</p>
		<br/>
		<p>
		Chúng tôi cấm tất cả người dùng tham gia vào các cuộc trò chuyện hoặc hoạt động liên quan đến:
		</p>
		<br/>
		<ol>
			<li>Bóc lột người / trẻ em</li>
			<li>Vũ khí</li>
			<li>Đầu độc con người</li>
			<li>Mọi hoạt động đe dọa tính mạng</li>
			<li>Lừa đảo</li>
			<li>Gian lận / lừa đảo / đầu tư thất bại</li>
			<li>Trộm cắp</li>
			<li>Phát tán nội dung khiêu dâm</li>
			<li>Bài bạc</li>
			<li>Phá thai</li>
			<li>Buôn bán, quảng bá và sử dụng Rượu, Ma túy, Chất gây nghiện và các chất gây nghiện bất hợp pháp khác.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Hành vi thù địch, bắt nạt, quấy rối và bạo lực
		</p>
		<br/>
		<p>
		Chúng tôi muốn tạo ra một cộng đồng lành mạnh và thoải mái cho người dùng. Do đó, chúng tôi không dung thứ cho bất kỳ hành động phân biệt đối xử nào đối với một số cá nhân hoặc nhóm nhất định.
		</p>
		<br/>
		<p>
		Vui lòng không chia sẻ bài viết / phản hồi / nhận xét:
		</p>
		<br/>
		<ol>
			<li>Gọi những người dùng khác là động vật, đồ vật vô tri hoặc theo bất kỳ cách thức xúc phạm nào</li>
			<li>Kêu gọi hoặc biện minh cho bất kỳ hành vi bạo lực nào đối với các cá nhân hoặc nhóm khác</li>
			<li>Tuyên bố về quyền tối cao đối với một nhóm người dựa trên chủng tộc, dân tộc, tôn giáo, nguồn gốc quốc gia, bệnh nặng, khuyết tật, v.v.</li>
			<li>Cáo buộc hoặc vu khống một số cá nhân hoặc nhóm cụ thể là tội phạm.</li>
			<li>Các bài đăng / phản hồi / nhận xét sử dụng những lời nói tục tĩu hoặc gay gắt</li>
			<li>Xúc phạm hoặc hạ thấp chủng tộc, sắc tộc, tôn giáo, nguồn gốc quốc gia, bệnh nặng, khuyết tật, v.v.</li>
			<li>Đe doạ các cá nhân khác</li>
			<li>Chia sẻ thông tin cá nhân của người khác với mục đích xấu hoặc theo cách khác</li>
			<li>Xúc phạm và xúi giục xúc phạm cá nhân khác.</li>
		</ol>
		<br/>
		<p>
		Chúng tôi cũng không khoan nhượng khi các thành viên trong cộng đồng của chúng tôi bị sỉ nhục, bắt nạt hoặc quấy rối. Do đó, bất kỳ bài đăng / phản hồi / nhận xét nào có bất kỳ biểu hiện bạo lực, bao gồm cả lời đe dọa hoặc phát biểu miệt thị nhằm chế giễu, xúc phạm, làm nhục, đe dọa, làm tổn thương ai đó hoặc những từ ngữ có thể gây đau khổ tâm lý nghiêm trọng sẽ bị xóa khỏi nền tảng của chúng tôi.
		</p>
		<br/>
		<p>
		Chúng tôi cũng không cho phép bất kỳ loại bài đăng nào có yếu tố quấy rối tình dục.
		</p>
		<br/>
		<p>
		Vui lòng không chia sẻ các bài đăng / phản hồi / nhận xét có chứa các yếu tố:
		</p>
		<br/>
		<ol>
			<li>Chê bai các hoạt động tình dục của người khác</li>
			<li>Thay đổi hoặc chỉnh sửa hình ảnh của người khác để hiển thị hoặc ngụ ý gợi ý tình dục hoặc tham gia vào các hoạt động tình dục</li>
			<li>Đe dọa hoặc tiết lộ đời sống tình dục riêng tư của ai đó, bao gồm đe dọa xuất bản nội dung kỹ thuật số, lịch sử tình dục, tên của bạn tình trước đây, xu hướng tình dục, v.v.</li>
			<li>Đe dọa hoặc tiết lộ xu hướng tình dục của người khác</li>
		</ol>
		<br/>
		<p>
		Ngoài ra, chúng tôi cũng không cho phép người dùng chia sẻ các bài đăng có yếu tố bạo lực, chẳng hạn như:
		</p>
		<br/>
		<ol>
			<li>Bạo dâm / Cắt âm đạo</li>
			<li>Vết thương hở</li>
			<li>Tai nạn</li>
			<li>Xác chết</li>
			<li>Các chi bị cắt rời hoặc cháy đen</li>
			<li>Bạo lực</li>
			<li>Tra tấn, v.v.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Tự tử, tự làm hại bản thân và các hành vi nguy hiểm khác
		</p>
		<br/>
		<p>
		Là một nền tảng nuôi dạy con cái, chúng tôi quan tâm sâu sắc đến sức khỏe và sự an toàn của người dùng.
		</p>
		<br/>
		<p>
		Vì lý do này, chúng tôi không chấp nhận bất kỳ bài đăng nào mô tả, quảng bá hoặc bình thường hóa bất kỳ hoạt động nào liên quan đến tự tử, tự gây thương tích hoặc các hoạt động nguy hiểm có thể gây tổn hại nghiêm trọng hoặc thậm chí tử vong.
		</p>
		<br/>
		<p className='point-title'>
		Quảng cáo
		</p>
		<br/>
		<p>
		Chúng tôi cố gắng cung cấp sự tiện lợi cho mọi người dùng của chúng tôi. Vì lý do này, chúng tôi chỉ cho phép các bài viết liên quan đến khuyến mãi, hoạt động mua bán hoặc quà tặng được đăng trong chủ đề Mua bán.
		</p>
		<br/>
		<p>
		Chúng tôi sẽ xóa các bài đăng / phản hồi / nhận xét / liên kết thương mại điện tử / liên kết truyền thông xã hội có chứa các yếu tố quảng cáo, mua và bán hoặc quà tặng bên ngoài chủ đề Mua và Bán.
		</p>
		<br/>
		<p>
		Chúng tôi KHÔNG cho phép bán hoặc quản lý bất kỳ loại thuốc nào trên dịch vụ của chúng tôi!
		</p>
		<br/>
		<p>
		Không có loại thuốc nào có thể được cung cấp hoặc bán bởi người dùng trên nền tảng này.
		</p>
		<br/>
		<p>
		Vì vậy, vui lòng không chia sẻ các bài đăng / phản hồi / nhận xét có chứa:
		</p>
		<br/>
		<ol>
			<li>
			Đề xuất liên quan đến việc sử dụng hoặc quản lý thuốc
			</li>
			<li>
			Quảng cáo hoặc bán hóa chất, thuốc, thảo mộc, v.v.
			</li>
		</ol>
		<br/>
		<p className='point-title'>
		theAsianparent Quan Tâm Đến Sự An Toàn Của Gia Đình Bạn Từ COVID-19
		</p>
		<br/>
		<p>
		Kể từ khi Tổ chức Y tế Thế giới (WHO) tuyên bố COVID-19 là đại dịch vào tháng 1 năm 2020, chúng tôi là theAsianparent đã nỗ lực để giữ an toàn cho cộng đồng của chúng ta bằng cách đảm bảo cộng đồng có quyền truy cập thông tin chính xác và hạn chế việc lan truyền thông tin sai lệch.
		</p>
		<br/>
		<p>
		Dưới đây là tổng quan cách chúng tôi giải quyết vấn đề này:
		</p>
		<br/>
		<p>
		Chúng tôi bảo vệ cộng đồng của mình khỏi những kẻ tiếp tục lan truyền thông tin sai lệch.
		</p>
		<br/>
		<p>
		Mục tiêu của chúng tôi là cung cấp một cộng đồng và một môi trường an toàn, hỗ trợ và chăm sóc cho các bậc cha mẹ trong thời kỳ đại dịch. Để giải quyết vấn đề này, chúng tôi tích cực giám sát Nội dung do Người dùng Tạo (UGC)*, gắn cờ và xóa mọi nội dung không phù hợp đề cập đến vi rút, kích động người dùng về Tổ chức Y tế Thế giới (WHO), cũng như các bộ y tế của chính quyền địa phương.
		</p>
		<br/>
		<p>
		Trước khi truy cập ứng dụng, người dùng được yêu cầu đồng ý với các điều khoản sử dụng và / hoặc chính sách người dùng của ứng dụng trước khi tạo hoặc tải lên nội dung.
		</p>
		<br/>
		<p>
		Theo cách tương tự, chúng tôi xử lý nội dung không phù hợp trong cộng đồng của mình.
		</p>
		<br/>
		<p>
		Dưới đây là cách chúng tôi đối phó với những người vi phạm và ngăn chặn sự lây lan của thông tin sai lệch liên quan đến vi rút:
		</p>
		<br/>
		<p>
		Nếu một thành viên trong cộng đồng của chúng tôi cố gắng chia sẻ bất kỳ nội dung hoặc bài đăng nào (bao gồm câu hỏi, câu trả lời, hình ảnh và/hoặc video, liên kết, hashtag) liên quan đến COVID-19, nội dung đó sẽ tự động được hệ thống của chúng tôi phát hiện để người kiểm duyệt nội bộ xem xét. Sau đó, người dùng cũng sẽ nhận được thông báo trực tiếp đến trang web của WHO và bộ y tế địa phương.
		Chúng tôi cho phép người dùng gắn cờ nội dung không phù hợp, sau đó yêu cầu người kiểm duyệt của chúng tôi xem xét nội dung bị gắn cờ.
		</p>
		<br/>
		<p>
		Sau đây là nội dung không phù hợp liên quan đến COVID-19:
		</p>
		<br/>
		<ol>
			<li>Bán PPE, bao gồm quần áo bảo hộ và giày dép, khẩu trang, mũ bảo hiểm và kính bảo hộ;</li>
			<li>Yêu cầu quyên góp thay mặt cho các tình nguyện viên và các doanh nghiệp cũng như cộng đồng bị ảnh hưởng bởi đại dịch. Đổi lại, chúng tôi sẽ hướng người dùng đến các đường dây nóng chính thức của họ;</li>
			<li>Nội dung gây hiểu lầm</li>
			<li>Nội dung liên quan đến việc lan truyền tin đồn và tin tức giả mạo.</li>
		</ol>
		<br/>
		<h2 className='faq'>
		Các Câu Hỏi Thường Gặp (FAQ)
		</h2>
		<br/>
		<p className='point-title'>
		Ai là người quyết định những Nguyên tắc cộng đồng bao gồm những gì?
		</p>
		<br/>
		<p>
		theAsianparent là một cộng đồng bao gồm những người từ các nền văn hóa, lứa tuổi và tín ngưỡng khác nhau.
		</p>
		<br/>
		<p>
			Chúng tôi đã cố gắng hiểu các quan điểm khác nhau để tạo ra một cộng đồng thoải mái, an toàn và cởi mở cho tất cả mọi người.
		</p>
		<br/>
		<p>
		Các Nguyên tắc cộng đồng này được tạo ra để chúng tôi có thể nuôi dưỡng và bảo vệ cộng đồng của mình.
		</p>
		<br/>
		<p className='point-title'>
		Ai kiểm duyệt nền tảng của chúng tôi?
		</p>
		<br/>
		<p>
		Để kiểm duyệt cộng đồng hàng ngày của chúng tôi, chúng tôi được hỗ trợ bởi một hệ thống tiên tiến có thể phát hiện những vi phạm Nguyên tắc cộng đồng của người dùng.
		</p>
		<br/>
		<p>
		Tuy nhiên, chúng tôi có người kiểm duyệt để có thể kiểm tra kỹ hệ thống và các quyết định do hệ thống đưa ra.
		</p>
		<br/>
		<p className='point-title'>
		Tôi thấy rằng một bài đăng, phản hồi hoặc nhận xét trên nền tảngAsianparent vi phạm Nguyên tắc cộng đồng. Tôi phải làm gì đây?
		</p>
		<br/>
		<p>
		Nếu bạn biết người dùng nào khác đang vi phạm Nguyên tắc cộng đồng của chúng tôi, vui lòng báo cáo họ.
		</p>
		<br/>
		<p>
		Bạn có thể nhấn vào tùy chọn “BÁO CÁO NGƯỜI DÙNG” từ menu bằng cách nhấn vào 3 dấu chấm (...) ở góc trên bên phải của mỗi bài đăng / phản hồi / nhận xét. 
		</p>
		<br/>
		<p>
		Hoặc bạn cũng có thể gửi báo cáo qua email cho chúng tôi (kèm theo bằng chứng) đến <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>.
		</p>
		<br/>
		<p className='point-title'>
		Điều gì xảy ra nếu ai đó vi phạm Nguyên tắc cộng đồng của chúng tôi?
		</p>
		<br/>
		<p>
		Chúng tôi có chính sách xóa tất cả nội dung vi phạm Nguyên tắc cộng đồng của mình và có thể xóa toàn bộ bài đăng nếu hình ảnh hoặc văn bản được liên kết vi phạm Nguyên tắc cộng đồng của chúng tôi.
		</p>
		<br/>
		<p>
		Chúng tôi cũng có thể vô hiệu hóa tất cả các tài khoản vi phạm Nguyên tắc cộng đồng và thông báo cho cơ quan thực thi pháp luật, nếu chúng tôi tin rằng có nguy cơ gây tổn hại về thể chất hoặc đe dọa đến an toàn công cộng.
		</p>
		<br/>
		<p className='point-title'>
		Bài đăng / phản hồi / bình luận của tôi đột nhiên biến mất, điều gì đã xảy ra?
		</p>
		<br/>
		<p>
		Hiện tại theAsianparent có Hệ thống kiểm duyệt tự động có thể phát hiện các bài đăng / nhận xét có chứa yếu tố bắt nạt / spam / phân biệt chủng tộc / ảnh bất hợp pháp / thô tục và các nội dung không phù hợp khác.
		</p>
		<br/>
		<p>
		Hệ thống Kiểm duyệt Tự động của chúng tôi cũng sẽ theo dõi bài đăng / nhận xét theo các quy trình hiện có (xóa bài đăng / nhận xét, chặn người dùng, v.v.).
		</p>
		<br/>
		<p>
		Chúng tôi sẽ tiếp tục theo dõi Hệ thống Kiểm duyệt Tự động để quy trình kiểm duyệt trở nên hoàn hảo hơn cũng như sẽ xem xét lại các bài đăng / bình luận được hệ thống phát hiện.
		</p>
		<br/>
		<p>
		Nếu bài viết / bình luận không chứa các yếu tố nêu trên, chúng tôi sẽ kích hoạt lại bài viết / bình luận trong vòng 1x24 giờ (ngày làm việc).
		</p>
		<br/>
		<p className='point-title'>
		Tại sao người dùng có thể đăng bài bằng tính năng Ẩn danh?
		</p>
		<br/>
		<p>
		Mục đích của tính năng ẩn danh là giúp các bậc cha mẹ muốn chia sẻ những điều nhạy cảm mà họ không thể nói với người khác.
		</p>
		<br/>
		<p>
		Nếu bạn nhận thấy bất kỳ sự lạm dụng nào đối với tính năng ẩn danh, vui lòng báo cáo cho chúng tôi theo địa chỉ <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. Chúng tôi sẽ kiểm tra và theo dõi.
		</p>
		<br/>
		<p className='point-title'>
		Ảnh NSFW là gì?
		</p>
		<br/>
		<p>
		Tag NSFW (Not Safe For Work) nghĩa là ảnh chứa nội dung nhạy cảm, được tạo ra nhằm mục đích ngăn những người dùng khác bị quấy rầy khi đăng một số ảnh nhạy cảm nhất định.
		</p>
		<br/>
		<p>
		Khi đính kèm ảnh vào bài đăng, bạn có thể tìm thấy tùy chọn "NSFW" này ở cuối ảnh. Bằng cách đánh dấu "NSFW", ảnh sẽ bị mờ và xuất hiện cảnh báo là ảnh "không an toàn để xem".
		</p>
		<br/>
		<p>
		Chúng tôi phân loại một số ảnh là "NSFW" cụ thể là cơ quan sinh dục nữ hoặc nam (có thể là trẻ sơ sinh hoặc người lớn), ảnh có chất dịch từ cơ quan sinh dục nữ hoặc nam; ảnh khỏa thân (có thể là trẻ sơ sinh hoặc người lớn), phân người / trẻ sơ sinh, tã bẩn, chất nôn, đồ lót bẩn, vết thương, chất nhầy, máu, v.v.
		</p>
		<br/>
		<p>
		Nếu bức ảnh "thiếu tế nhị" này không được đăng dưới dạng NSFW, chúng tôi sẽ xóa bức ảnh và có thể đình chỉ tài khoản đã tải nó lên.
		</p>

		<br/><br/>
		<p>Hãy cùng nhau vui mừng vì chúng ta đã và đang góp phần nuôi dạy những ngôi sao hạnh phúc, khỏe mạnh và tự tin của tương lai!</p>
		<p className="covid-rule-title">&mdash;Từ đội ngũ nhân viên theAsianparent, chúng tôi cám ơn bạn!</p>
		<br/><br/>
	</Fragment>
);

const ContentPhHtml = () => (
    <Fragment>
    	<div className="community-guildeline-title-wrapper">		
			<h1 className="community-guildeline-title">
				theAsianparent Community Guidelines
			</h1>
		</div>
		<div className="starting-para">
			<p>
			Hi Parents! Sobrang excited na kaming makasama mo sa’yong parenthood journey!
			</p>
			<br/>
			<p>
			Inaanyayahan namin ang lahat ng moms and dads (at pati na rin ang mga magiging magulang pa lang) to stay in touch sa aming platform para magbigay ng mga advice at stories base sa kanilang personal na karanasan.
			</p>
			<br/>
			<p>
			Subalit, pinapaalalahanan namin ang mga magulang na huwag husgahan ang isa’t isa kahit na hindi pareho ang ating mga opinyon sa parenting styles, cultures, ages, beliefs, etc.
			</p>
			<br/>
			<p>
			At para masiguradong maayos ang security at comfort sa ating community, please make sure na tayo po ay sumunod sa mga guidelines na ito:
			</p>
		</div>
		<br />
		<p className="point-title">
		Integrity and identity
		</p>
		<br />
		<p>
		Hindi dapat manggaya o mangopya ng identity ng ibang tao lalo pa’t makakasama ito sa ibang users.
		</p>
		<br/>
		<p>
			Kapag may report ukol sa panggagaya or impersonation, we will confirm and ask the user na baguhin ang kanilang profile.
		</p>
		<p>
		Hindi rin kami mag-aatubiling mag-suspend or block ng account.
		</p>
		<br/>
		<p>
		Bukod dito, hindi rin kami pumapayag ng mag-share ang mga users ng maling impormasyon ukol sa:
		</p>
		<br/>
		<ol>
			<li>Emergencies that could cause panic</li>
			<li>Incitement to hatred or prejudice against other people, certain groups, or society</li>
			<li>Medical misinformation that could harm a person's physical health</li>
			<li>Content that misleads community members about politics</li>
			<li>Conspiracy content that attacks certain groups</li>
			<li>Violent or tragic events.</li>
		</ol>
		<br/>
		<p>
		Hindi rin namin pinapayagan ang mga users na mag-share ng identity na mayroong personal or individual privacy information.
		</p>
		<br/>
		<p>
		Hindi kami responsable sa mga losses na maaring mangyari dahil sa pag-share ng personal na impormasyon ng mga user. Dahil sa kadahilanang ito, hindi rin namin nire-rekomend sa mga users na mag-share ng personal impormasyon tulad nito:
		</p>
		<br/>
		<ol>
			<li>Place and date of birth</li>
			<li>telephone number</li>
			<li>NIK(KTP main number)</li>
			<li>Complete address of residence</li>
			<li>Photo of identification card (KTP, SIM, Family Card, Birth certificate, etc.)</li>
			<li>Certificate ownership (house certificate, land certificate, etc.)</li>
			<li>Full name of mother and father</li>
			<li>Sign in information (username and password)</li>
			<li>Debit/credit card number, etc.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Inappropriate images
		</p>
		<br/>
		<p>
			Bilang isang platform para sa parenting at pregnancy, naiintindihan namin kung kailangan talagang magpalitan ng kuwento tungkol sa spots/ vaginal discharge/ baby poop at iba pa sa ibang users.
		</p>
		<br/>
		<p>
		Subalit, maaring hindi ito magustuhan ng ibang users.
		</p>
		<br/>
		<p>
		Dahil dito, huwag sana tayong mag-post ng sensitive images tulad ng human/baby feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, at iba pa ng hindi nilalagyan ng <i>tag</i> na NSFW (Not Safe for Work).
		</p>
		<br/>
		<p>
		Ang mga users na magpo-post ng sexually explicit photos, especially children, ay agad na tatanggalin.
		</p>
		<br/>
		<p className='point-title'>
		Spam
		</p>
		<br/>
		<p>
		Bilang aming commitment na magbigay sa users ng magandang karanasan kapag nakikipag-interact sa aming platform, tatanggalin namin lahat ng spam content
		</p>
		<br/>
		<p>
		At hiling din sana namin na hindi mag-post ang mga user ng content na spam o similar dito.
		</p>
		<br/>
		<p>
		Hindi namin sinusuportahan ang pag-post ng mga ito:
		</p>
		<br/>
		<ol>
			<li>Share a post/response/comment more than 2 (two) times with the same words or sentences</li>
			<li>Containing <i>spam</i> elements, such as: up, “period”, “comma”, etc.</li>
			<li>Provide comments that contain spam elements on personal or other people's posts with the aim of increasing posts to the homepage</li>
			<li>Robotic text such as: nendifniuha3jr. 12345678, asdfghjkl, etc</li>
			<li>Prohibitory sentence so that other users do not answer a post, such as "Posts from 1 year ago do not respond!"</li>
			<li>Linking to other websites whose security cannot be guaranteed (whatsapp group links, Facebook, Instagram, Line, etc.)</li>
		</ol>
		<br/>
		<p className='point-title'>Illegal activities </p>
		<br/>
		<p>
		Hindi namin sinusuportahan ang mga gawain na lumalabag sa mga batas. Dahil dito, pinagbabawal sa platform na ito lahat ng gawain na kriminal.
		</p>
		<br/>
		<p>
		Pinagbabawalan ang lahat ng user sa platform sa pagsali sa mga usapan o gawain na may kaugnayan dito:
		</p>
		<br/>
		<ol>
			<li>Exploitation of people/children</li>
			<li>Weapons</li>
			<li>Poisoning of humans</li>
			<li>Any life-threatening activities</li>
			<li>Phishing</li>
			<li>Fraud/scam/false investment</li>
			<li>Theft</li>
			<li>Spreading pornography</li>
			<li>Gambling</li>
			<li>Abortion</li>
			<li>Trafficking, promotion and use of Alcohol, Drugs, Substances and other illegal drugs.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Hateful, bullying, harassment and violent behavior
		</p>
		<br/>
		<p>
		Gusto namin makagawa ng ligtas at komportableng community para sa mga users. Kaya naman pinagbabawal ang pag discriminate sa kahit sinong mga indibidwal at mga grupo.
		</p>
		<br/>
		<p>
		Please don't share posts/ feedback/ comments:
		</p>
		<br/>
		<ol>
			<li>Referring negatively to other Individuals as animals, inanimate objects, or in any derogatory manner</li>
			<li>Calling for or justifying any acts of violence against other individuals or groups</li>
			<li>Claims of supremacy over a group of people based on race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
			<li>Accusing or slandering certain individuals or groups as criminals</li>
			<li>Posts/ responses/ comments that use slurs or harsh words</li>
			<li>Insulting or demeaning race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
			<li>Threats to other individuals</li>
			<li>Sharing personal details of others with malicious intent or otherwise</li>
			<li>Insults and solicitation of insults towards other individuals.</li>
		</ol>
		<br/>
		<p>
		Hindi rin namin pinapayagan ang members ng aming community na mamahiya o mam-bully o mangharass. Kaya naman, kahit anong post/response/comment na merong expressions of violence, including threats or disparaging statements intended to ridicule, insult, humiliate, intimidate, hurt someone or words that can cause severe psychological distress ay tatanggalin mula sa aming platform.
		</p>
		<br/>
		<p>
		Hindi rin namin pinapayagan ang kahit anong klase ng posts na mayroong elemento ng sexual harassment.
		</p>
		<br/>
		<p>
		Huwag po tayong mag-share ng posts/feedback/comments that contain elements of:
		</p>
		<br/>
		<ol>
			<li>Disparage other people's sexual practices</li>
			<li>Altering or morphing other people's images to display or imply sexual suggestion or involvement in sexual activities</li>
			<li>Threatening or disclosing someone's private sex life, including threats to publish digital content, sex history, names of previous sexual partners, sexual orientation, etc.</li>
			<li>Threatening or exposing the sexual orientation of others</li>
		</ol>
		<br/>
		<p>
		Dagdag pa dito, hindi rin namin pinapayagan ang mga user na mag-share ng posts na may elemento ng violence, tulad ng:
		</p>
		<br/>
		<ol>
			<li>Sadism/Mutilation</li>
			<li>Open wounds</li>
			<li>Accidents</li>
			<li>Corpses</li>
			<li>Mutilated, charred or burned limbs</li>
			<li>Violence</li>
			<li>Torture, etc.</li>
		</ol>
		<br/>
		<p className='point-title'>Suicide, self-harm and other dangerous acts</p>
		<br/>
		<p>
		Bilang isang parenting platform, lubhang importante sa’min ang kalusugan at kaligtasan ng aming users.
		</p>
		<br/>
		<p>
		Dahil dito, hindi pinapayagan ang mga post na: depicts, promotes or normalises any activity that leads to suicide, self-injury, or dangerous activities that can cause serious injury or even death. 
		</p>
		<br/>
		<p className='point-title'>
		Promotions
		</p>
		<br/>
		<p>
		Pinipilit namin na magbigay ng convenience sa bawat user sa aming application. Dahil dito, pinapayagan lang namin ang mga posts na may kaugnayan sa promotions, buying and selling at giveaways kapag ito ay naka-post sa Buying and Selling topic.
		</p>
		<br/>
		<p>
		Buburahin namin lahat ng posts/responses/comments/ecommerce links/social media links na may laman na promotion, buying and selling or ,<i>giveaways</i> kapag ito ay nasa labas ng Buying and Selling <i>topic</i>.
		</p>
		<br/>
		<p>
		We DO NOT allow the sale or administration of any drugs on our service!  Bawal ang mga gamot.
		</p>
		<br/>
		<p>
		Walang gamot na maaring ipamigay o ibenta ang mga users sa platform na ito.
		</p>
		<br/>
		<p>
		Kaya kung maari, don't share posts/responses/comments that contain:
		</p>
		<br/>
		<ol>
			<li>Suggestions for the use or administration of drugs </li>
			<li>Promotion or sale of chemicals, drugs, herbs, etc.</li>
		</ol>
		<br/>
		<p className='point-title'>theAsianparent Cares About Your Family's Safety from COVID-19</p>
		<br/>
		<p>
		Mula nang ideklara ng World Health Organization (WHO) ang COVID-19 na isang pandemya noong Enero 2020, kami sa theAsianparent ay nagsumikap na panatilihing ligtas ang aming komunidad sa pamamagitan ng pagtiyak na mayroon silang access sa tumpak na impormasyon at nililimitahan ang pagkalat ng maling impormasyon.
		</p>
		<br/>
		<p>
		Narito ang ilan sa mga hakbang kung paano namin ito tinutugunan:
		</p>
		<br/>
		<p>
		Pinoprotektahan namin ang aming komunidad mula sa mga nagpapatuloy at nagkakalat ng maling impormasyon.
		</p>
		<br/>
		<p>
		Ang aming layunin ay magbigay ng ligtas, matulungin at mapagmalasakit na komunidad at kapaligiran para sa mga magulang sa panahon ng pandemya. Upang matugunan ito, aktibong sinusubaybayan namin ang User Generated Content (UGC)*, at i-flag at inaalis ang anumang hindi naaangkop na content* na tumutukoy sa mga virus, na pumupukaw sa mga user tungkol sa World Health Organization (WHO), gayundin sa mga ministri ng kalusugan ng lokal na pamahalaan.
		</p>
		<br/>
		<p>
		Bago i-access ang application, ang mga user ay kinakailangang sumang-ayon sa mga tuntunin ng paggamit ng application at/o mga patakaran ng user bago gumawa o mag-upload ng nilalaman.
		</p>
		<br/>
		<p>
		Sa parehong paraan, nakikitungo kami sa hindi naaangkop na nilalaman sa aming komunidad.
		</p>
		<br/>
		<p>
		Narito kung paano namin hinarap ang mga lumalabag at pinipigilan ang pagkalat ng maling impormasyon na nauugnay sa virus:
		</p>
		<br/>
		<ol>
			<li>Kung sinubukan ng isang miyembro ng aming komunidad na magbahagi ng anumang content o mga post (kabilang ang mga tanong, tugon, larawan at/o video, link, hashtag) na nauugnay sa COVID-19, awtomatikong matutukoy ng aming system ang content para tingnan ng mga internal na moderator. Pagkatapos nito, makakatanggap din ang mga user ng notification na nagdidirekta sa kanila sa website ng WHO at sa lokal na ministeryo sa kalusugan.</li>
			<li>Pinapayagan namin ang mga user na mag-flag ng hindi naaangkop na nilalaman, pagkatapos ay hilingin sa aming mga moderator na suriin ang na-flag na nilalaman.</li>
		</ol>
		<br/>
		<p>Ang sumusunod ay hindi naaangkop na content na nauugnay sa COVID-19:</p>
		<br/>
		<ol>
			<li>Pagbebenta ng PPE, kabilang ang protective clothing at kasuotan sa paa, mga maskara, helmet, at salaming de kolor;</li>
			<li>Humiling ng mga donasyon sa ngalan ng mga boluntaryo at negosyo at komunidad na apektado ng pandemya - bilang kapalit ay ididirekta namin ang mga user sa kanilang mga opisyal na hotline;</li>
			<li>Nakapanlinlang na content</li>
			<li>Content na kinabibilangan ng pagkalat ng tsismis at pekeng balita.</li>
		</ol>
		<br/>
		<h2 className='faq'>Frequently Asked Questions (FAQ)</h2>
		<br/>
		<p className='point-title'>
		Sino ang nagpapasya kung ano ang dapat saklawin ng Community Guidelines?
		</p>
		<br/>
		<p>
		angAsianparent ay isang komunidad ng mga tao mula sa magkakaibang kultura, edad at paniniwala.
		</p>
		<br/>
		<p>
		Sinubukan naming maunawaan ang iba't ibang pananaw upang lumikha ng komportable, ligtas at bukas na komunidad para sa lahat.
		</p>
		<br/>
		<p>Nilikha ang Community Guidelines na ito upang mapangalagaan at maprotektahan natin ang ating komunidad.</p><br/>
		<p className='point-title'>Sino ang nagmo-moderate sa aming plataporma?</p>
		<br/>
		<p>
		Para sa aming pang-araw-araw na pagmo-moderate ng komunidad, kami ay tinutulungan ng isang advanced na sistema na tutukoy ng mga paglabag sa Community Guidelines by users.
		</p>
		<br/>
		<p>
		Gayunpaman, i-double check ng ating mga human moderator ang system at ang mga desisyong ginawa nito.
		</p>
		<br/>
		<p className='point-title'>
		Nakikita ko na ang isang post, tugon o komento sa platform ngAsianparent ay lumalabag sa Community Guidelines. Ano ang kailangan kong gawin?
		</p>
		<br/>
		<p>
		Kung alam mong may ibang user na lumalabag sa aming Community Guidelines, please report them.
		</p>
		<br/>
		<p>
		You can tap the “REPORT USER” option from the menu <i>drop-down</i> which can be found by tapping the 3 dots (...) in the upper right corner of each post/response/comment. 
		</p>
		<br/>
		<p>
		You can also email us the report (with evidence) to <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. 
		</p>
		<br/>
		<p className='point-title'>
		Ano ang mangyayari kung may lumabag sa ating Community Guidelines?
		</p>
		<br/>
		<p>
		We have a policy for removing content that violates our Community Guidelines. We may remove an entire post if the associated image or text violates our Community Guidelines. 
		</p>
		<br/>
		<p>We may also disable all accounts that violate our Community Guidelines.</p>
		<br/>
		<p>
		We may inform law enforcement, if we believe there is a risk of physical harm or threat to public safety. 
		</p>
		<br/>
		<p className='point-title'>
		Biglang nawala ang post/response/comment ko, anong nangyari?
		</p>
		<br/>
		<p>
		Sa kasalukuyan angAsianparent ay may Automatic Moderation System na maaaring makakita ng mga post/komento na naglalaman ng mga elemento ng bullying/spam/racist/illegal/bulgar na mga larawan at iba pang hindi naaangkop na content.
		</p>
		<br/>
		<p>
		Ang aming Automatic Moderation System ay mag-follow up din sa post/komento ayon sa mga kasalukuyang pamamaraan (pagtanggal ng mga post/komento, pagharang sa mga user, at iba pa).
		</p>
		<br/>
		<p>
		Patuloy naming susubaybayan ang Automatic Moderation System para mas maging perpekto ito. Susuriin din namin ang mga post/komento na nakita ng system.
		</p>
		<br/>
		<p>
		Kung ang post/komento ay hindi naglalaman ng mga elementong nabanggit sa itaas, muli namin itong isaaktibo sa loob ng 1x24 na oras (araw ng trabaho).
		</p>
		<br/>
		<p className='point-title'>
		Bakit maaaring mag-post ang mga user gamit ang feature na Anonymous?
		</p>
		<br/>
		<p>
		Ang layunin ng anonymous na feature ay tulungan ang mga magulang na gustong magbahagi ng mga sensitibong bagay na hindi nila masasabi sa iba.
		</p>
		<br/>
		<p>
		Kung may napansin kang anumang pang-aabuso sa hindi kilalang feature, mangyaring iulat ito sa amin sa <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. We will follow up.
		</p>
		<br/>
		<p className='point-title'>
		Ano ang isang larawan na NSFW?
		</p>
		<br/>
		<p>
			Ang tag ng NSFW (Not Safe For Work) ay naglalayong pigilan ang ibang mga user na maabala sa pamamagitan ng pag-post ng ilang partikular na larawan.
        </p>
		<p>
		Kapag nag-attach ng larawan sa isang post, makikita mo itong "NSFW" na checkbox sa ibaba ng larawan. Sa pamamagitan ng pag-tick sa "NSFW", malabo ang larawan at may lalabas na babala bilang isang "hindi ligtas na tingnan" na larawan.
		</p>
		<br/>
		<p>
		Ikinategorya namin ang ilang larawan bilang "hindi ligtas na tingnan" katulad ng babae o lalaki na ari (maging ito ay isang sanggol o nasa hustong gulang), mga larawan ng likido mula sa babae o lalaki na ari; mga hubad na larawan (sanggol man o matanda), dumi ng tao/sanggol, maruruming lampin, suka, maruming damit na panloob, sugat, uhog, dugo, at iba pa.
		</p>
		<br/>
		<p>
		Kung ang "bulgar" na larawang ito ay hindi nai-post bilang NSFW, tatanggalin namin ang larawan at maaaring suspindihin ang account na nag-upload nito.
		</p>






		


		<br/><br/>
		<p>Cheers to raising happy, healthy, and confident kids!</p>
		<p className="covid-rule-title">&mdash;theAsianparent Team</p>
		<br/><br/>
	</Fragment>
);

const ContentMyHtml = (props) => (
    <Fragment>
    	<div className="language-tabs">
			<div onClick={() => props.openTab('english', 'englishContent', 'malay')} id="englishContent" className="tab-label">English</div>
			<div onClick={() => props.openTab('malay', 'malayContent', 'malay')} id="malayContent" className={`tab-label tab-visited`}>Malay</div>
		</div>

		<div id="malay" className={`tabcontent`}>
	    	<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title">
					Garis Panduan Komuniti theAsianparent 
				</h1>
			</div>
			<div className="starting-para">
				<p>
				Hi Ibu dan Ayah! Kami sangat gembira anda menyertai kami dalam meniti perjalanan keibubapaan ini!
				</p>
				<br/>
				<p>
				Kami mengalu-alukan dan menggalakkan ibu dan bapa untuk saling berhubung di antara satu sama lain dan berkongsi tips dan nasihat berdasarkan pengalaman peribadi anda.
				</p>
				<br/>
				<p>
				Namun, kami menyarankan ibu bapa untuk tidak menghukum para ibu bapa lain walaupun berlainan gaya keibubapaan, budaya, umur, kepercayaan dan lain-lain.
				</p>
				<br/>
				<p>
				Di samping itu, bagi mengekalkan keselesaan dan keselamatan di dalam komuniti, sila pastikan anda mematuhi garis panduan berikut: 
				</p>
			</div>
			<br />
			<p className="point-title">
			Integriti Dan Identiti
			</p>
			<br/>
			<p>
			Kami tidak akan menggalakkan penyamaran seseorang atau entiti yang boleh membahayakan pengguna lain.
			</p>
			<br/>
			<p>
			Jika terdapat laporan penyamaran, kami akan mengesahkan dan meminta pengguna untuk menyemak profil mereka.  
			</p>
			<br/>
			<p>
			Kami juga tidak teragak-agak untuk menggantung atau menyekat akaun tersebut. 
			</p>
			<p>
			Dengan itu, kami tidak membenarkan pengguna untuk berkongsi maklumat tidak benar berkaitan dengan:  	
			</p>
			<br/>
			<ol>
				<li>Kecemasan yang boleh menyebabkan panik</li>
				<li>Hasutan berupa hasad dengki atau prejudis terhadap orang lain, sesuatu kumpulan atau masyarakat.</li>
				<li>Maklumat perubatan tidak benar yang boleh membahayakan kesihatan fizikal seseorang.</li>
				<li>Kandungan yang mengelirukan ahli komuniti mengenai politik</li>
				<li>Kandungan konspirasi yang menyerang beberapa kumpulan</li>
				<li>Acara yang berunsur ganas atau tragik</li>
			</ol>
			<br/>
			<p>
			Selain itu, kami tidak membenarkan pengguna berkongsi identiti yang mengandungi maklumat privasi peribadi atau individu. 
			</p>
			<br/>
			<p>
			Kami tidak akan bertanggungjawab untuk mana-mana kehilangan disebabkan perkongsian maklumat peribadi oleh pengguna. Atas sebab ini, kami juga tidak menyarankan pengguna untuk berkongsi maklumat peribadi dalam bentuk: 
			</p>
			<br/>
			<ol>
				<li>Tempat dan Tarikh Lahir</li>
				<li>No Telefon</li>
				<li>Nombor IC</li>
				<li>Alamat penuh tempat tinggal</li>
				<li>Gambar IC (Surat Beranak, Kad Keluarga dan lain-lain)</li>
				<li>Sijil Pemilikan (Sijil Rumah, Sijil Tanah dan lain-lain)</li>
				<li>Nama penuh ibu atau ayah</li>
				<li>Maklumat log masuk (username dan password)</li>
				<li>Nombor kad debit/kredit dan lain-lain</li>
			</ol>
			<br/>
			<p className="point-title">
			Gambar Yang Tidak Bersesuaian
			</p>
			<br/>
			<p>
			Sebagai platform keibubapaan dan kehamilan, kami sangat memahami jika anda ingin berkongsi pengalaman berkaitan dengan keputihan, najis bayi dan sebagainya dengan pengguna lain.
			</p>
			<br/>
			<p>
			Malangnya, perkara ini mungkin membuatkan pengguna lain berasa tidak selesa. 
			</p>
			<br/>
			<p>
			Atas sebab ini, kami tidak menyarankan pengguna untuk menyiarkan imej sensitif seperti najis bayi, lampin kotor, muntah, seluar dalam kotor, luka, hingus, darah dan lain-lain tanpa menggunakan <i>tag</i> NSFW (Not Safe for Work).
			</p>
			<br/>
			<p>
			Pengguna yang menyiarkan post gambar seksual eksplisit, terutamanya kanak-kanak, akan dibuang.
			</p>
			<br/>
			<p className="point-title">
			Spam
			</p>
			<br/>
			<p>
			Sebagai komitmen untuk menyediakan pengguna pengalaman yang baik apabila berinteraksi di platform kami, kami akan menghapuskan kandungan <i>spam</i>. 
			</p>
			<br/>
			<p>
			Untuk itu, kami meminta setiap pengguna untuk tidak berkongsi kandungan atau terlibat dalam kandungan yang berupa <i>spammy</i>.
			</p>
			<br/>
			<p>
			Kami tidak menyokong semua post, respons atau komen:  
			</p>
			<br/>
			<ol>
				<li>Kongsi post/respons/komen melebihi dari 2 (dua) kali dengan perkataan atau ayat yang sama.</li>
				<li>Mengandungi elemen spam, seperti: atas, “noktah”, “koma”, dan lain-lain.</li>
				<li>Menyediakan komen yang mengandungi elemen spam pada post peribadi atau orang lain dengan tujuan menaikkan post ke halaman utama.</li>
				<li>Teks robotik seperti: nendifniuha3jr. 12345678, asdfghjkl, dan lain-lain</li>
				<li>Ayat larangan supaya pengguna lain tidak menjawab post, seperti “Post dari 1 tahun lepas, jangan respons!”</li>
				<li>Menghubungkan pautan laman web lain di mana keselamatannya tidak dapat dijamin (group WhatsApp, Facebook, Instagram, Line dan lain-lain).</li>
			</ol>
			<br/>
			<p className="point-title">
				Aktiviti Haram/Dilarang
			</p>
			<br/>
			<p>
			Kami tidak menyokong aktiviti yang melanggar undang-undang dan peraturan. Atas sebab ini, kami melarang semua aktiviti berkaitan dengan tindakan jenayah di platform kami.
			</p>
			<br/>
			<p>
			Kami melarang semua pengguna di platform kami dari melibatkan diri dalam sebarang aktiviti yang berkaitan dengan: 
			</p>
			<br/>
			<ol>
				<li>Eksploitasi orang/kanak-kanak </li>
				<li>Senjata</li>
				<li>Merosakkan manusia</li>
				<li>Aktiviti yang mengancam nyawa</li>
				<li>Pencurian data</li>
				<li>Penipuan/scam/pelaburan palsu</li>
				<li>Kecurian</li>
				<li>Menyebarkan pornografi</li>
				<li>Perjudian</li>
				<li>Gugur kandungan</li>
				<li>Pemerdagangan, promosi dan penggunaan Alkohol, Dadah dan Bahan dan dadah haram yang lain.</li>
			</ol>
			<br/>
			<p className='point-title'>
			Tingkah Laku: Kebencian, Buli, Gangguan & Keganasan
			</p>
			<br/>
			<p>
			Kami ingin mencipta komuniti yang selamat dan selesa untuk pengguna. Oleh itu, kami tidak bertolak ansur dengan sebarang tindakan diskriminasi terhadap sesetengah individu atau kumpulan. 
			</p>
			<br/>
			<p>
			Tolong jangan kongsi post/maklum balas/komen: 
			</p>
			<br/>
			<ol>
				<li>
				Merujuk secara negatif kepada individu lain sebagai haiwan, objek tidak bernyawa, atau dalam sebarang cara penghinaan.
				</li>
				<li>Menyeru atau menunjukkan sebarang tindakan keganasan terhadap individu atau kumpulan lain.</li>
				<li>Tuntutan kuasa atas sekumpulan orang berdasarkan kaum, etnik, agama, negara asal, penyakit serius, hilang upaya dan lain-lain.</li>
				<li>Tuduhan atau fitnah terhadap sesetengah individu atau kumpulan sebagai penjenayah.</li>
				<li>Post/respons/komen yang menggunakan kata-kata kasar atau cemuhan.</li>
				<li>Menghina atau merendahkan kaum, etnik, agama, negara asal, penyakit serius, hilang upaya dan lain-lain.</li>
				<li>Ancaman terhadap individu lain.</li>
				<li>Berkongsi maklumat peribadi orang lain dengan niat jahat atau sebaliknya.</li>
				<li>Penghinaan terhadap individu lain.</li>
			</ol>
			<br/>
			<p>
			Kami juga tidak akan bertolak ansur apabila pengguna di komuniti kami dihina, dibuli atau diganggu. Oleh itu, sebarang post/respons/komen yang mengandungi sebarang ekspresi keganasan, termasuk ancaman atau kenyataan yang merendah-rendahkan bertujuan untuk mencemuh, menghina, memalukan, menakut-nakutkan, mencederakan seseorang atau perkataan yang boleh menyebabkan tekanan psikologi yang teruk akan dikeluarkan dari platform kami.  
			</p>
			<br/>
			<p>
				Kami juga tidak membenarkan sebarang bentuk siaran yang mengandungi elemen gangguan seksual.
			</p>
			<br/>
			<p>
			Tolong jangan kongsi posts/maklum balas/komen yang mengandungi elemen: 
			</p>
			<br/>
			<ol>
				<li>Memperlekehkan amalan seksual orang lain.</li>
				<li>Mengubah atau menyunting imej orang lain untuk paparan atau membayangkan cadangan amalan seksual.</li>
				<li>Mengancam atau mendedahkan kehidupan seks orang lain, termasuk ugutan untuk menyiarkan kandungan digital, sejarah seks, nama pasangan seksual terdahulu, orientasi seksual, dan lain-lain.</li>
				<li>Mengancam atau mendedahkan orientasi seksual orang lain.</li>
			</ol>
			<br/>
			<p>
			Untuk itu, kami juga tidak membenarkan pengguna untuk kongsi post yang mengandungi elemen berunsur keganasan, seperti: 
			</p>
			<br/>
			<ol>
				<li>Sadisme/Kecacatan</li>
				<li>Luka terbuka</li>
				<li>Kemalangan</li>
				<li>Mayat</li>
				<li>Anggota badan yang telah cacat, hangus atau terbakar</li>
				<li>Keganasan</li>
				<li>Penyeksaan, dan lain-lain</li>
			</ol>
			<br/>
			<p className='point-title'>
			Bunuh Diri, Mencederakan Diri Dan Tindakan Bahaya Yang Lain
			</p>
			<br/>
			<p>
			Sebagai platform <i>keibubapaan</i>, kami sangat mengambil berat tentang kesihatan dan kesihatan pengguna kami.
			</p>
			<br/>
			<p>
			Atas sebab ini, kami tidak menggalakan sebarang post yang menggambarkan, mempromosi atau menormalisasi mana-mana aktiviti yang membawa kepada bunuh diri, mencederakan diri, atau aktiviti berbahaya yang boleh menyebabkan kecederaan serius atau kematian.
			</p>
			<br/>
			<p className='point-title'>
			Promosi
			</p>
			<br/>
			<p>
			Kami berusaha untuk menyediakan kemudahan untuk setiap pengguna aplikasi kami. Atas sebab ini, kami hanya membenarkan post berkaitan promosi, jual beli atau <i>giveaway</i> untuk disiarkan di dalam <i>topik</i> Jual Beli.
			</p>
			<br/>
			<p>
			Kami akan memadam post/respons/komen/pautan edagang/media sosial yang mengandungi elemen promosi, jual beli atau <i>giveaway</i> di luar <i>topik</i> Jual Beli.
			</p>
			<br/>
			<p>
			Kami TIDAK membenarkan jualan atau pemberian sebarang ubat di dalam perkhidmatan kami! 
			</p>
			<br/>
			<p>
				Tiada jenis ubat boleh diberikan atau dijual pada pengguna di platform kami.
			</p>
			<br/>
			<p>
			Jadi, tolong jangan kongsikan post/respons/komen yang mengandungi: 
			</p>
			<br/>
			<ol>
				<li>Cadangan untuk penggunaan atau pemberian ubat.</li>
				<li>Promosi atau jualan bahan kimia, ubat, herba dan lain-lain.</li>
			</ol>
			<br/>
			<p className='point-title'>
			theAsianparent Mengambil Berat Tentang Keselamatan Keluarga Anda Dari COVID-19
			</p>
			<br/>
			<p>
			Sejak Pertubuhan Kesihatan Sedunia (WHO) mengisytiharkan COVID-19 sebagai pandemik pada Januari 2020, kami di theAsianparent bekerja keras untuk memastikan komuniti kami selamat dengan memastikan mereka mempunyai akses kepada maklumat tepat dan menghadkan penyebarang maklumat yang tidak sahih.
			</p>
			<br/>
			<p>
			Berikut adalah gambaran keseluruhan bagaimana kami menangani isu ini: 
			</p>
			<br/>
			<p>
			Kami menjaga komuniti kami daripada mereka yang mengekalkan dan menyebarkan maklumat tidak sahih.
			</p>
			<br/>
			<p>
			Matlamat kami adalah untuk menyediakan komuniti dan persekitaran yang selamat, mendukung dan menyayangi untuk ibu bapa sewaktu pandemik. Untuk menangani isu ini, kami memantau secara aktif User Generated Content (UGC)*, dan membuang mana-mana kandungan yang tidak bersesuaian* yang merujuk kepada virus, mencetuskan provokasi pada pengguna mengenai Pertubuhan Kesihatan Sedunia (WHO), begitu juga dengan Kementerian Kesihatan Kerajaan tempatan.
			</p>
			<br/>
			<p>
			Sebelum mengakses aplikasi kami, pengguna diminta untuk bersetuju dengan terma penggunaan dan/atau dasar pengguna aplikasi sebelum mencipta atau memuat naik kandungan.
			</p>
			<br/>
			<p>
			Dengan cara yang sama, kami berurusan dengan kandungan yang tidak bersesuaian di dalam komuniti kami.
			</p>
			<br/>
			<p>
			Berikut adalah cara kami menangani pelaku dan mencegah penyebaran palsu berkaitan virus: 
			</p>
			<br/>
			<ol>
				<li>Jika pengguna komuniti kami mencuba untuk berkongsi apa-apa kandungan atau post (termasuk soalan, respons, gambar dan/atau video, pautan, hashtag) berkaitan COVID-19, kandungan tersebut akan dikesan secara automatik oleh sistem kami. Selepas itu, pengguna juga akan menerima pemberitahuan yang mengarahkan mereka ke laman web WHO dan Kementerian Kesihatan tempatan.</li>
				<li>Kami membenarkan pengguna untuk memberi isyarat untuk kandungan yang tidak bersesuaian, kemudian meminta moderator kami untuk menyemak kandungan yang dilaporkan. </li>
			</ol>
			<br/>
			<p>
			Berikut adalah kandungan berkaitan COVID-19 yang tidak bersesuaian:
			</p>
			<br/>
			<ol>
				<li>Penjualan PPE, termasuk pakaian dan kasut pelindung, topeng muka, topi keledar dan cermin mata. </li>
				<li>Meminta derma bagi pihak sukarelawan dan perniagaan dan komuniti yang terjejas oleh pandemik -kami akan mengarahkan pengguna ke talian rasmi.</li>
				<li>Kandungan yang mengelirukan.</li>
				<li>Kandungan yang melibatkan penyebaran khabar angin dan berita palsu.</li>
			</ol>
			<br/>
			<h2 className='faq'>
			Soalan Lazim (FAQ)
			</h2>
			<br/>
			<p className='point-title'>
			Siapa yang menentukan apa yang perlu dilindungi oleh Garis Panduan Komuniti?
			</p>
			<br/>
			<p>
			theAsianparent adalah komuniti dari pelbagai budaya, umur dan kepercayaan.
			</p>
			<br/>
			<p>
			Kami mencuba untuk memahami sudut pandangan yang berbeza untuk mewujudkan satu komuniti yang selesa, selamat dan terbuka untuk sesiapa sahaja. 
			</p>
			<br/>
			<p>
			Garis Panduan Komuniti ini dicipta supaya kita boleh bersama-sama memelihara dan melindungi komuniti ini.
			</p>
			<br/>
			<p className='point-title'>
			Siapa yang mengendalikan platform kami?
			</p>
			<br/>
			<p>
			Untuk pengendalian harian komuniti kami, kami dibantu oleh sistem yang akan mengesan sebarang pelanggaran Garis Panduan Komuniti oleh pengguna. 
			</p>
			<br/>
			<p>
			Namun, moderator manual (manusia) kami akan <i>menyemak semula</i> sistem dan keputusan akan dilakukan.
			</p>
			<br/>
			<p className='point-title'>
			Saya melihat post, respons atau komen di platform theAsianparent yang melanggar Panduan Komuniti. Apa yang perlu saya lakukan?
			</p>
			<br/>
			<p>
			Jika anda tahu pengguna lain melanggar Garis Panduan Komuniti kami, sila laporkan.	
			</p>
			<br/>
			<p>
			Anda boleh klik pilihan “LAPOR PENGGUNA” dari menu <i>drop-down</i> yang boleh anda temui dengan menekan 3 titik (...) di sudut kanan atas setiap post/respons/komen.
			</p>
			<br/>
			<p>
			Anda juga boleh emel ke kami laporan (beserta bukti) ke <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. 
			</p>
			<br/>
			<p className='point-title'>
			Apa yang terjadi jika seseorang melanggar Garis Panduan Komuniti kami?
			</p>
			<br/>
			<p>
			Kami mempunyai polisi untuk membuang kandungan yang melanggar Garis Panduan Komuniti kami. Kami mungkin memadam keseluruhan post jika gambar atau teks yang berkaitan melanggar Garis Panduan Komuniti. 
			</p>
			<br/>
			<p>
			Kami juga mungkin melumpuhkan semua akaun yang melanggar Garis Panduan Komuniti kami.
			</p>
			<br/>
			<p>
			Kami mungkin memaklumkan penguatkuasa undang-undang, jika kami merasakan terdapat bahaya secara fizikal atau ancaman kepada keselamatan awam.
			</p>
			<br/>
			<p className='point-title'>
			Post/Respon/Komen saya hilang secara tiba-tiba, apa yang berlaku?
			</p>
			<br/>
			<p>
			Saat ini theAsianparent Sistem Pengendalian Automatik yang boleh mengesan post/komen yang mengandungi elemen buli/spam/perkauman/haram/lucah berupa foto dan kandungan tidak bersesuaian yang lain.
			</p>
			<br/>
			<p>
			Sistem Pengendalian Automatik kami juga akan membuat susulan pada post/komen mengikut prosedur sedia ada (memadam post/komen, menyekat pengguna dan lain-lain).
			</p>
			<br/>
			<p>
			Kami akan terus memantau Sistem Pengendalian Automatik untuk menjadikan ia lebih sempurna. Kami juga akan memeriksa post/komen yang dikesan oleh sistem.
			</p>
			<br/>
			<p>
			Jika post/komen tidak mengandungi sebarang elemen yang dinyatakan seperti di atas, kami akan mengaktifkan semula dalam 1X24 jam (hari bekerja).
			</p>
			<br/>
			<p className='point-title'>
			Mengapa pengguna boleh memuat naik post menggunakan ciri Tanpa Nama?
			</p>
			<br/>
			<p>
			Tujuan utama ciri Tanpa Nama adalah untuk membantu ibu bapa yang ingin berkongsi perkara sensitif yang mereka tidak boleh beritahu kepada orang lain.
			</p>
			<p>
			Jika anda melihat sebarang penyalahgunaan ciri Tanpa Nama, sila laporkan kepada kami di <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. Kami akan membuat susulan.
			</p>
			<br/>
			<p className='point-title'>
			Apa itu gambar NSFW?
			</p>
			<br/>
			<p>
			NSFW <i>tag</i> (Not Safe for Work) bertujuan untuk mengelakan pengguna lain daripada terganggu dengan siaran gambar tertentu. 
			</p>
			<br/>
			<p>
			Apabila melampirkan gambar pada post, anda boleh menemui kotak "NSFW" di bahagian bawah gambar. Dengan menandakan "NSFW", gambar akan dikaburkan dan amaran akan dipaparkan sebagai gambar “tidak selamat untuk dilihat”.
			</p>
			<br/>
			<p>
			Kami mengkategorikan beberapa gambar sebagai “tidak selamat untuk dilihat” untuk kemaluan wanita dan lelaki (sama ada bayi mahupun dewasa), gambar cecair dari alat sulit wanita atau lelaki, gambar bogel (Sama ada bayi mahupun dewasa), najis, lampin kotor, muntah, seluar dalam kotor, luka, hingus, darag dan lain-lain.
			</p>
			<br/>
			<p>
			Jika gambar “lucah” tidak disiarkan sebagai NSFW, kami akan memadam gambar tersebut dan mungkin akan mengantung akaun yang memuat naik tersebut.
			</p>
			<br/><br/>
			<p>Semoga berjaya dalam membesarkan anak-anak yang bahagia, sihat, dan berkeyakinan!</p>
			<p className="covid-rule-title">&mdash;Pasukan theAsianparent</p>
			<br/><br/>
		</div>

		<div id="english" className={`tabcontent hide`}>
			<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title">
				theAsianparent Community Guidelines
				</h1>
				<br/>
			</div>
			<div className="starting-para">
				<p>
				Hi Parents! We are so excited that you can join us on your journey to parenthood!
				</p>
				<br />
				<p>
				We welcome and support moms and dads (or prospective parents) to stay in touch on our platform to share advice and stories based on personal experiences. 
				</p>
				<br />
				<p>
				However, we encourage parents not to judge each other despite differences in parenting styles, cultures, ages, beliefs, etc.
				</p>
				<br/>
				<p>
				In addition, in order to maintain security and comfort in the community, please make sure to adhere to the following guidelines:
				</p>
			</div>
			<br/>
			<p className='point-title'>
				Integrity and identity
			</p>
			<br/>
			<p>
				We do not condone impersonating a person or entity that can harm other users. 
			</p>
			<br/>
			<p>
			If there is a report of impersonation, we will confirm and ask the user to revise their profile. 
			</p>
			<br/>
			<p>
			We also do not hesitate to suspend or block the account. 
			</p>
			<br/>
			<p>
			In addition, we do not allow users to share misinformation related to: 
			</p>
			<br/>
			<ol>
				<li>Emergencies that could cause panic </li>
				<li>Incitement to hatred or prejudice against other people, certain groups, or society </li>
				<li>Medical misinformation that could harm a person's physical health</li>
				<li>Content that misleads community members about politics  </li>
				<li>Conspiracy content that attacks certain groups </li>
				<li>Violent or tragic events.</li>
			</ol>
			<br/>
			<p>
			In addition, we do not allow users to share identity that contains personal or individual privacy information. 
			</p>
			<br/>
			<p>
			We are not responsible for any losses incurred as a result of sharing personal information by users. For this reason, we also do not recommend that users share personal information in the form of:
			</p>
			<br/>
			<ol>
				<li>Place and date of birth</li>
				<li>telephone number</li>
				<li>NIK(KTP main number)</li>
				<li>Complete address of residence</li>
				<li>Photo of identification card (KTP, SIM, Family Card, Birth certificate, etc.)</li>
				<li>Certificate ownership (house certificate, land certificate, etc.)</li>
				<li>Full name of mother and father</li>
				<li>Sign in information (username and password)</li>
				<li>Debit/credit card number, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
				Inappropriate images
			</p>
			<br/>
			<p>
			As a platform for parenting and pregnancy, we really understand if you want to exchange stories related to spots/ vaginal discharge/ baby poop and so on with other users.
			</p>
			<br/>
			<p>
			Unfortunately, this may make other users feel less comfortable.
			</p>
			<br/>
			<p>
			For this reason, we do not recommend users to post sensitive images such as human/baby feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on without using <i>the tag</i> NSFW (Not Safe for Work).
			</p>
			<br/>
			<p>
			Users who post sexually explicit photos, especially children, will be removed.
			</p>
			<br/>
			<p className='point-title'>
			Spam 
			</p>
			<br/>
			<p>
			As our commitment to provide users with a good experience when interacting on our platform, we will remove any <i>spam</i> content. 
			</p>
			<br/>
			<p>
			To that end, we ask each user not to share content or engage in spammy behavior.  
			</p>
			<br/>
			<p>
			We do not support all of the following posts, responses or comments:
			</p>
			<br/>
			<ol>
				<li>Share a post/response/comment more than 2 (two) times with the same words or sentences</li>
				<li>Containing <i>spam</i> elements, such as: up, “period”, “comma”, etc.</li>
				<li>Provide comments that contain spam elements on personal or other people's posts with the aim of increasing posts to the homepage.</li>
				<li>Robotic text such as: nendifniuha3jr. 12345678, asdfghjkl, etc.</li>
				<li>Prohibitory sentence so that other users do not answer a post, such as "Posts from 1 year ago do not respond!"</li>
				<li>Linking to other websites whose security cannot be guaranteed (whatsapp group links, Facebook, Instagram, Line, etc.)</li>
			</ol>
			<br/>
			<p className='point-title'>
			Illegal activities 
			</p>
			<br/>
			<p>
			We do not support activities that violate laws and regulations. For this reason, we prohibit all activities related to criminal acts on our platform.
			</p>
			<br/>
			<p>
			We prohibit all user on the platform from participating in conversations or activities related to: 
			</p>
			<br/>
			<ol>
				<li>Exploitation of people/children</li>
				<li>Weapons</li>
				<li>Poisoning of humans</li>
				<li>Any life-threatening activities</li>
				<li>Phishing</li>
				<li>Fraud/scam/false investment</li>
				<li>Theft</li>
				<li>Spreading pornography</li>
				<li>Gambling</li>
				<li>Abortion</li>
				<li>Trafficking, promotion and use of Alcohol, Drugs, Substances and other illegal drugs.</li>
			</ol>
			<br/>
			<p className='point-title'>
			Hateful, bullying, harassment and violent behavior
			</p>
			<br/>
			<p>
			We want to create a safe and comfortable community for users. Therefore, we do not tolerate any act of discrimination against certain individuals or groups.
			</p>
			<br/>
			<p>
			Please don't share posts/ feedback/ comments: 
			</p>
			<br/>
			<ol>
				<li>Referring negatively to other Individuals as animals, inanimate objects, or in any derogatory manner </li>
				<li>Calling for or justifying any acts of violence against other individuals or groups</li>
				<li>Claims of supremacy over a group of people based on race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
				<li>Accusing or slandering certain individuals or groups as criminals</li>
				<li>Posts/ responses/ comments that use slurs or harsh words</li>
				<li>Insulting or demeaning race, ethnicity, religion, national origin, serious illness, disability, etc.</li>
				<li>Threats to other individuals</li>
				<li>Sharing personal details of others with malicious intent or otherwise</li>
				<li>Insults and solicitation of insults towards other individuals.</li>
			</ol>
			<br/>
			<p>
			We also do not tolerate when members of our community are humiliated, bullied or harassed. Therefore, any post/response/comment that contains any expressions of violence, including threats or disparaging statements intended to ridicule, insult, humiliate, intimidate, hurt someone or words that can cause severe psychological distress will be removed from our platform.
			</p>
			<br/>
			<p>
			We also do not allow any form of posts that contain elements of sexual harassment.
			</p>
			<br/>
			<p>
			Please do not share posts/feedback/comments that contain elements of:
			</p>
			<br/>
			<ol>
				<li>Disparage other people's sexual practices</li>
				<li>Altering or morphing other people's images to display or imply sexual suggestion or involvement in sexual activities</li>
				<li>Threatening or disclosing someone's private sex life, including threats to publish digital content, sex history, names of previous sexual partners, sexual orientation, etc.</li>
				<li>Threatening or exposing the sexual orientation of others</li>
			</ol>
			<br/>
			<p>
			In addition, we also do not allow users to share posts that contain elements of violence, such as:
			</p>
			<br/>
			<ol>
				<li>Sadism/Mutilation</li>
				<li>Open wounds</li>
				<li>Accidents</li>
				<li>Corpses </li>
				<li>Mutilated, charred or burned limbs</li>
				<li>Violence</li>
				<li>Torture, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
			Suicide, self-harm and other dangerous acts
			</p>
			<br/>
			<p>
			As a <i>parenting</i> platform, we care deeply about the health and safety of our users. 
			</p>
			<br/>
			<p>
			For this reason, we do not condone any post that depicts, promotes or normalises any activity that leads to suicide, self-injury, or dangerous activities that can cause serious injury or even death. 
			</p>
			<br/>
			<p className='point-title'>
			Promotions
			</p>
			<br/>
			<p>
			We strive to provide convenience to every user of our application. For this reason, we only allow posts related to promotions, buying and selling activities or <i>giveaways</i> to be posted in the Buying and Selling <i>topic</i>.
			</p>
			<br/>
			<p>
			We will delete posts/responses/comments/ecommerce links/social media links that contain elements of promotion, buying and selling or <i>giveaways</i> outside the Buying and Selling <i>topic</i>
			</p>
			<br/>
			<p>
			We DO NOT allow the sale or administration of any drugs on our service! 
			</p>
			<br/>
			<p>
			No type of medicines may be given or sold by users on this platform.
			</p>
			<br/>
			<p>
			So, please don't share posts/responses/comments that contain:
			</p>
			<br/>
			<ol>
				<li>Suggestions for the use or administration of drugs</li>
				<li>Promotion or sale of chemicals, drugs, herbs, etc.</li>
			</ol>
			<br/>
			<p className='point-title'>
			theAsianparent Cares About Your Family's Safety from COVID-19
			</p>
			<br/>
			<p>
			Since the World Health Organisation (WHO) declared COVID-19 a pandemic in January 2020, we at theAsianparent have worked hard to keep our community safe by ensuring they have access to accurate information and limiting the spread of false information.
			</p>
			<br/>
			<p>
			Here's an overview of how we address this:
			</p>
			<br/>
			<p>
			We protect our community from those who perpetuate and spread false information.
			</p>
			<br/>
			<p>
			Our goal is to provide a safe, supportive and caring community and environment for parents during the pandemic. To address this, we actively monitor User Generated Content (UGC)*, and flag and remove any inappropriate content* that refers to viruses, provokes users about the World Health Organisation (WHO), as well as local government ministries of health.
			</p>
			<br/>
			<p>
			Before accessing the application, users are required to agree to the application's terms of use and/or user policies before creating or uploading content.
			</p>
			<br/>
			<p>
			In the same way, we deal with inappropriate content in our community.
			</p>
			<br/>
			<p>
			Here's how we deal with violators and prevent the spread of virus-related misinformation:
			</p>
			<br/>
			<ol>
				<li>If a member of our community tries to share any content or posts (including questions, responses, images and/or videos, links, hashtags) related to COVID-19, the content will automatically be detected by our system for internal moderators to look at. After that, users will also receive a notification directing them to the WHO website and the local health ministry.</li>
				<li>We allow users to flag inappropriate content, then ask our moderators to review the flagged content.</li>
			</ol>
			<br/>
			<p>
			The following is inappropriate content related to COVID-19:
			</p>
			<br/>
			<ol>
				<li>Sales of PPE, including protective clothing and footwear, masks, helmets, and goggles;</li>
				<li>Request donations on behalf of volunteers and businesses and communities affected by the pandemic - in return we will direct users to their official hotlines;</li>
				<li>Misleading content</li>
				<li>Content that involves spreading rumors and fake news.</li>
			</ol>
			<br/>
			<h2 className='faq'>Frequently Asked Questions (FAQ)</h2>
			<br/>
			<p className='point-title'>
				Who decides what the Community Guidelines should cover?
			</p>
			<br/>
			<p>
			theAsianparent is a community of people from diverse cultures, ages and beliefs.
			</p>
			<br/>
			<p>
			We have tried to understand different points of view to create a comfortable, safe and open community for everyone. 
			</p>
			<br/>
			<p>
			These Community Guidelines were created so that we can nurture and protect our community.
			</p>
			<br/>
			<p className='point-title'>
			Who moderates our platform?
			</p>
			<br/>
			<p>
			For our day-to-day moderation of the community, we are assisted by an advanced system that will detect violations of the Community Guidelines by users.
			</p>
			<br/>
			<p>
			However, our human moderators double check the system and the decisions made by it.
			</p>
			<br/>
			<p className='point-title'>
			I see that a post, response or comment on theAsianparent platform violates the Community Guidelines. What do I have to do?
			</p>
			<br/>
			<p>
			If you know another user is violating our Community Guidelines, please report them.
			</p>
			<br/>
			<p>
			You can tap the “REPORT USER” option from the menu drop-down which can be found by tapping the 3 dots (...) in the upper right corner of each post/response/comment.
			</p>
			<br/>
			<p>
			You can also email us the report (with evidence) to <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>
			</p>
			<br/>
			<p className='point-title'>
			What happens if someone violates our Community Guidelines?
			</p>
			<br/>
			<p>
			We have a policy for removing content that violates our Community Guidelines. We may remove an entire post if the associated image or text violates our Community Guidelines.
			</p>
			<br/>
			<p>
			We may also disable all accounts that violate our Community Guidelines.
			</p>
			<br/>
			<p>
			We may inform law enforcement, if we believe there is a risk of physical harm or threat to public safety.
			</p>
			<br/>
			<p className='point-title'>
			My post/response/comment suddenly disappeared, what happened?
			</p>
			<br/>
			<p>
			Currently theAsianparent has an Automatic Moderation System that can detect posts/comments that contain elements of bullying/spam/racist/illegal/vulgar photos and other inappropriate content.
			</p>
			<br/>
			<p>
			Our Automatic Moderation System will also follow up on the post/comment according to existing procedures (deleting posts/comments, blocking users, and so on).
			</p>
			<br/>
			<p>
			We will continue to monitor the Automatic Moderation System to make it even more perfect. We will also review posts/comments detected by the system.
			</p>
			<br/>
			<p>
			If the post/comment does not contain the elements mentioned above, we will reactivate it within 1x24 hours (working days).
			</p>
			<br/>
			<p className='point-title'>
			Why can users post using the Anonymous feature?
			</p>
			<br/>
			<p>
			The purpose of the anonymous feature is to help parents who want to share sensitive things that they can't tell others.
			</p>
			<br/>
			<p>
			If you notice any abuse of the anonymous feature, please report it to us at <a href="mailto:app.feedback@theasianparent.com">app.feedback@theasianparent.com</a>. We will follow up.
			</p>
			<br/>
			<p className='point-title'>
			What is an NSFW photo?
			</p>
			<br/>
			<p>
			<i>The</i> NSFW <i>tag</i> (Not Safe for Work) aims to prevent other users from being disturbed by posting certain photos.
			</p>
			<br/>
			<p>
			When attaching a photo to a post, you can find this "NSFW" checkbox at the bottom of the photo. By ticking "NSFW", the photo will be blurred and a warning will appear as an "unsafe to view" photo.
			</p>
			<br/>
			<p>
			We categorise several photos as "unsafe to view" namely female or male genitalia (be it a baby or adult), photos of fluid from female or male genitalia; nude photos (be it a baby or an adult), human/infant feces, dirty diapers, vomit, dirty underwear, wounds, mucus, blood, and so on.
			</p>
			<br/>
			<p>
			If this "vulgar" photo is not posted as NSFW, we will delete the photo and may suspend the account that uploaded it.
			</p>
			<br/><br/>
			<p>Cheers to raising happy, healthy, and confident kids!</p>
			<p className="covid-rule-title">&mdash;theAsianparent Team</p>
			<br/><br/> 
		</div>
	</Fragment>
);

const ContentBeYeuHtml = () => (
    <Fragment>		
		<div className="community-guildeline-title-wrapper">		
				<h1 className="community-guildeline-title">
				    Tiêu chuẩn dành cho cộng đồng Bé Yêu
				</h1>
		</div>
		<br/>

		<div className="starting-para">
			<p>
			Bé Yêu hiện đã và đang trở thành một cộng đồng có hàng triệu mẹ sử dụng mỗi ngày, với những hoạt động cập nhật, chia sẻ kiến thức sôi nổi và kết nối chặt chẽ. Bên cạnh đó, chúng tôi nhận thức rõ về tầm quan trọng của Bé Yêu trong việc xây dựng một nơi mà các thành viên cảm thấy có quyền được tôn trọng. Vì vậy, chúng tôi rất nghiêm túc về vai trò của mình trong việc ngăn chặn những hành vi lạm dụng dịch vụ của chúng tôi với việc phát triển một bộ Tiêu chuẩn cộng đồng, trong đó nêu ra những gì ĐƯỢC PHÉP và KHÔNG ĐƯỢC PHÉP trên ứng dụng Bé Yêu.
			</p>
		</div>
		<br/>
		<p className='point-title'>
		Thuần phong mỹ tục
		</p>
		<br/>
		<p>
		Thuần phong mỹ tục có thể hiểu là những phong tục, tập quán, lối sống văn minh, tốt đẹp và lành mạnh. Những giá trị này đã đi sâu vào đời sống xã hội, được xã hội công nhận và làm theo.
		</p>
		<br/>
		<p>
		Với mong muốn xây dựng một cộng đồng chia sẻ lành mạnh, hữu ích, Bé Yêu cũng sẽ ngăn chặn những hành vi đi ngược lại với các giá trị thuần phong mỹ tục của xã hội. Cụ thể, những hành động dưới đây sẽ bị cấm:
		</p>
		<br/>
		<ol>
			<li>Đăng tải những hình ảnh có nội dung phản cảm, khiêu gợi, hở hang, mất thẩm mỹ.</li>
			<li>Sử dụng từ ngữ thô tục, khiêu khích, bôi nhọ người khác hay quảng bá văn hóa phẩm đồi trụy.</li>
			<li>Chia sẻ, đăng tải, quảng cáo các nội dung liên quan tới bài bạc, tổ chức đánh đề, chơi hụi, các cược…</li>
		</ol>
		<br/>
		<p className='point-title'>
		Quảng cáo, Spam
		</p>
		<br/>
		<p>
		Chúng tôi nỗ lực để hạn chế lan truyền các bài đăng spam thương mại, để ngăn chặn các quảng cáo có tính chất lừa đảo, gian lận và vi phạm bảo mật thông tin. Hậu quả là những hành vi này đều làm giảm khả năng chia sẻ và kết nối của các thành viên.
		</p>
		<br/>
		<p>
		Những bài viết dưới đây sẽ được xem là quảng cáo, spam:
		</p>
		<br/>
		<ol>
			<li>Đăng bài với nội dung quảng cáo bán hàng, bất kể mặt hàng được phép hoặc bị cấm theo quy định của pháp luật.</li>
			<li>Bình luận kêu gọi quảng bá sản phẩm, hàng hóa, dịch vụ không thuộc ngữ cảnh nội dung của bài đăng.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Các hành vi quấy rối, bạo lực
		</p>
		<br/>
		<p>
		Mục đích của điều khoản này nhằm ngăn chặn mối nguy hại tiềm ẩn ngoài đời thật, có thể liên quan đến các nội dung trên Bé Yêu. Chúng tôi cũng cố gắng xem xét ngôn ngữ, bối cảnh để phân biệt những câu chữ vô tình với nội dung cấu thành mối đe dọa có thể xảy ra, đe dọa sự an toàn của cá nhân hay cộng đồng.
		</p>
		<br/>
		<p>
		Những nội dung sau đây có thể xem là hành vi quấy rối, bạo lực:
		</p>
		<br/>
		<ol>
			<li>Nội dung đe dọa có thể dẫn đến cái chết của bất kỳ ai, là mục tiêu mà nội dung đe dọa nhắm đến.</li>
			<li>Nội dung yêu cầu hoặc cung cấp dịch vụ hoặc ủng hộ việc sử dụng bạo lực để trả thù, sử dụng những người đâm thuê chém mướn.</li>
			<li>Lời thú nhận, lời lẽ thể hiện ý định hoặc sự ủng hộ, nội dung kêu gọi hành động hay tuyên bố thể hiện mong muốn/điều kiện để bắt cóc một mục tiêu nào đó.</li>
			<li>Nội dung đe dọa gây ra tổn hại về thể chất (hoặc hình thức bạo lực khác có mức độ nghiêm trọng thấp hơn) cho người khác.</li>
			<li>Cung cấp, hướng dẫn cách chế tạo hoặc sử dụng thuốc nổ.</li>
			<li>Thông tin sai lệch góp phần cổ xúy hành vi bạo lực hoặc hành vi gây tổn hại thể chất sắp xảy ra.</li>
			<li>Lời kêu gọi hành động, tuyên bố thể hiện ý định mang vũ khí đến địa điểm nào đó hoặc khuyến khích người khác làm điều tương tự.	</li>
		</ol>
		<br/>
		<p className='point-title'>
		Chính trị, an ninh, hàng cấm
		</p>
		<br/>
		<p>
		Bé Yêu luôn nỗ lực ngăn chặn và loại bỏ những mối nguy cho cộng đồng, nên chúng tôi không cho phép bất kỳ tổ chức hoặc cá nhân nào sử dụng Bé Yêu vào các tuyên bố chính trị, an ninh hoặc tham gia vào việc buôn bán hàng cấm.
		</p>
		<br/>
		<p>
		Điều khoản này bao gồm việc cấm các tổ chức, cá nhân sử dụng Bé Yêu để tham gia vào các hoạt động sau:
		</p>
		<br/>
		<ol>
			<li>Hoạt động khủng bố</li>
			<li>Hoạt động thù ghét có tổ chức</li>
			<li>Hoạt động tội phạm hoặc bạo lực có tổ chức	</li>
			<li>Hoạt động buôn bán hàng hóa có trong danh mục bị cấm theo quy định của pháp luật.</li>
		</ol>
		<br/>
		<p className='point-title'>
		Thông tin sai lệch
		</p>
		<br/>
		<p>
		Chúng tôi muốn đảm bảo rằng nội dung mà các thành viên thấy trên Bé Yêu đều là xác thực. Chúng tôi cho rằng thông tin xác thực sẽ tạo ra môi trường tốt hơn để chia sẻ và kết nối. Vì vậy chúng tôi không muốn thành viên của mình sử dụng Bé Yêu để đưa ra những thông tin sai lệch như:
		</p>
		<br/>
		<ol>
			<li>Sử dụng hình ảnh của người khác với mục đích đánh lừa người khác.</li>
			<li>Tạo một trang cá nhân giả mạo hoặc phát ngôn thay cho người khác, tổ chức khác.</li>
			<li>Tạo một trang giả mạo hoặc phát ngôn cho người khác, tổ chức khác mà không được ủy quyền làm như vậy.</li>
			<li>Đăng hình ảnh với nội dung có thể lừa gạt người khác về nguồn gốc của nội dung đó.</li>
		</ol>
		<br/><br/>
		<p>Hãy cùng nhau vui mừng vì chúng ta đã và đang góp phần nuôi dạy những ngôi sao hạnh phúc, khỏe mạnh và tự tin của tương lai!</p>
		<p className="covid-rule-title">&mdash;Từ đội ngũ nhân viên Bé Yêu, chúng tôi cám ơn bạn!</p>
		<br/><br/>
	</Fragment>
);